// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/company_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssessmentScore } from "../../assessment/v1/assessment_score_pb";
import { file_assessment_v1_assessment_score } from "../../assessment/v1/assessment_score_pb";
import type { User as User$1 } from "../../customer/management/v1/service_pb";
import { file_customer_management_v1_service } from "../../customer/management/v1/service_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AICapability, AIPosture, CompanyAIProfile } from "./ai_posture_pb";
import { file_inventory_v1_ai_posture } from "./ai_posture_pb";
import type { AlertStatus } from "./alert_pb";
import { file_inventory_v1_alert } from "./alert_pb";
import type { AlertCountStat } from "./alert_count_stat_pb";
import { file_inventory_v1_alert_count_stat } from "./alert_count_stat_pb";
import type { AssessmentDecision } from "./assessment_decision_pb";
import { file_inventory_v1_assessment_decision } from "./assessment_decision_pb";
import type { Comment } from "./comment_pb";
import { file_inventory_v1_comment } from "./comment_pb";
import type { CompanyLifecycle } from "./company_lifecycle_pb";
import { file_inventory_v1_company_lifecycle } from "./company_lifecycle_pb";
import type { CompanyStatus } from "./company_status_pb";
import { file_inventory_v1_company_status } from "./company_status_pb";
import type { ControlCountStat } from "./control_service_pb";
import { file_inventory_v1_control_service } from "./control_service_pb";
import type { Option } from "./custom_field_service_pb";
import { file_inventory_v1_custom_field_service } from "./custom_field_service_pb";
import type { CompanyOrEngagement } from "./entity_pb";
import { file_inventory_v1_entity } from "./entity_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Scope } from "./scope_pb";
import { file_inventory_v1_scope } from "./scope_pb";
import type { Tag } from "./tag_service_pb";
import { file_inventory_v1_tag_service } from "./tag_service_pb";
import type { TemplateBuilderCondition } from "./template_builder_lib_pb";
import { file_inventory_v1_template_builder_lib } from "./template_builder_lib_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/company_service.proto.
 */
export const file_inventory_v1_company_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_assessment_v1_assessment_score, file_customer_management_v1_service, file_google_protobuf_duration, file_google_protobuf_timestamp, file_inventory_v1_ai_posture, file_inventory_v1_alert, file_inventory_v1_alert_count_stat, file_inventory_v1_assessment_decision, file_inventory_v1_comment, file_inventory_v1_company_lifecycle, file_inventory_v1_company_status, file_inventory_v1_control_service, file_inventory_v1_custom_field_service, file_inventory_v1_entity, file_inventory_v1_risk, file_inventory_v1_scope, file_inventory_v1_tag_service, file_inventory_v1_template_builder_lib]);

/**
 * @generated from message inventory.v1.UpdateOrgCompanyReAssessmentDueDateRequest
 */
export type UpdateOrgCompanyReAssessmentDueDateRequest = Message<"inventory.v1.UpdateOrgCompanyReAssessmentDueDateRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp manual_due_date = 2;
   */
  manualDueDate?: Timestamp;

  /**
   * @generated from field: inventory.v1.ReAssessmentDueDateUpdateType update_type = 3;
   */
  updateType: ReAssessmentDueDateUpdateType;
};

/**
 * Describes the message inventory.v1.UpdateOrgCompanyReAssessmentDueDateRequest.
 * Use `create(UpdateOrgCompanyReAssessmentDueDateRequestSchema)` to create a new message.
 */
export const UpdateOrgCompanyReAssessmentDueDateRequestSchema: GenMessage<UpdateOrgCompanyReAssessmentDueDateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 0);

/**
 * @generated from message inventory.v1.UpdateOrgCompanyReAssessmentDueDateResponse
 */
export type UpdateOrgCompanyReAssessmentDueDateResponse = Message<"inventory.v1.UpdateOrgCompanyReAssessmentDueDateResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateOrgCompanyReAssessmentDueDateResponse.
 * Use `create(UpdateOrgCompanyReAssessmentDueDateResponseSchema)` to create a new message.
 */
export const UpdateOrgCompanyReAssessmentDueDateResponseSchema: GenMessage<UpdateOrgCompanyReAssessmentDueDateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 1);

/**
 * @generated from message inventory.v1.LinkSolutionsToCompanyRequest
 */
export type LinkSolutionsToCompanyRequest = Message<"inventory.v1.LinkSolutionsToCompanyRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: repeated string solution_ids = 2;
   */
  solutionIds: string[];
};

/**
 * Describes the message inventory.v1.LinkSolutionsToCompanyRequest.
 * Use `create(LinkSolutionsToCompanyRequestSchema)` to create a new message.
 */
export const LinkSolutionsToCompanyRequestSchema: GenMessage<LinkSolutionsToCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 2);

/**
 * @generated from message inventory.v1.LinkSolutionsToCompanyResponse
 */
export type LinkSolutionsToCompanyResponse = Message<"inventory.v1.LinkSolutionsToCompanyResponse"> & {
};

/**
 * Describes the message inventory.v1.LinkSolutionsToCompanyResponse.
 * Use `create(LinkSolutionsToCompanyResponseSchema)` to create a new message.
 */
export const LinkSolutionsToCompanyResponseSchema: GenMessage<LinkSolutionsToCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 3);

/**
 * @generated from message inventory.v1.CreateOrgCompanyEngagementRequest
 */
export type CreateOrgCompanyEngagementRequest = Message<"inventory.v1.CreateOrgCompanyEngagementRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: string org_company_id = 3;
   */
  orgCompanyId: string;

  /**
   * @generated from field: optional string integration_source = 4;
   */
  integrationSource?: string;

  /**
   * @generated from field: optional string product_id = 5;
   */
  productId?: string;
};

/**
 * Describes the message inventory.v1.CreateOrgCompanyEngagementRequest.
 * Use `create(CreateOrgCompanyEngagementRequestSchema)` to create a new message.
 */
export const CreateOrgCompanyEngagementRequestSchema: GenMessage<CreateOrgCompanyEngagementRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 4);

/**
 * @generated from message inventory.v1.CreateOrgCompanyEngagementResponse
 */
export type CreateOrgCompanyEngagementResponse = Message<"inventory.v1.CreateOrgCompanyEngagementResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateOrgCompanyEngagementResponse.
 * Use `create(CreateOrgCompanyEngagementResponseSchema)` to create a new message.
 */
export const CreateOrgCompanyEngagementResponseSchema: GenMessage<CreateOrgCompanyEngagementResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 5);

/**
 * @generated from message inventory.v1.UpdateOrgCompanyEngagementRequest
 */
export type UpdateOrgCompanyEngagementRequest = Message<"inventory.v1.UpdateOrgCompanyEngagementRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string comment = 4;
   */
  comment?: string;
};

/**
 * Describes the message inventory.v1.UpdateOrgCompanyEngagementRequest.
 * Use `create(UpdateOrgCompanyEngagementRequestSchema)` to create a new message.
 */
export const UpdateOrgCompanyEngagementRequestSchema: GenMessage<UpdateOrgCompanyEngagementRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 6);

/**
 * @generated from message inventory.v1.UpdateOrgCompanyEngagementResponse
 */
export type UpdateOrgCompanyEngagementResponse = Message<"inventory.v1.UpdateOrgCompanyEngagementResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateOrgCompanyEngagementResponse.
 * Use `create(UpdateOrgCompanyEngagementResponseSchema)` to create a new message.
 */
export const UpdateOrgCompanyEngagementResponseSchema: GenMessage<UpdateOrgCompanyEngagementResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 7);

/**
 * @generated from message inventory.v1.UpdateEngagementInherentRiskRequest
 */
export type UpdateEngagementInherentRiskRequest = Message<"inventory.v1.UpdateEngagementInherentRiskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 2;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: optional string comment = 3;
   */
  comment?: string;

  /**
   * @generated from field: optional string integration_source = 4;
   */
  integrationSource?: string;
};

/**
 * Describes the message inventory.v1.UpdateEngagementInherentRiskRequest.
 * Use `create(UpdateEngagementInherentRiskRequestSchema)` to create a new message.
 */
export const UpdateEngagementInherentRiskRequestSchema: GenMessage<UpdateEngagementInherentRiskRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 8);

/**
 * @generated from message inventory.v1.UpdateEngagementInherentRiskResponse
 */
export type UpdateEngagementInherentRiskResponse = Message<"inventory.v1.UpdateEngagementInherentRiskResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateEngagementInherentRiskResponse.
 * Use `create(UpdateEngagementInherentRiskResponseSchema)` to create a new message.
 */
export const UpdateEngagementInherentRiskResponseSchema: GenMessage<UpdateEngagementInherentRiskResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 9);

/**
 * @generated from message inventory.v1.DeleteOrgCompanyEngagementRequest
 */
export type DeleteOrgCompanyEngagementRequest = Message<"inventory.v1.DeleteOrgCompanyEngagementRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: string engagement_id = 2;
   */
  engagementId: string;

  /**
   * @generated from field: optional string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message inventory.v1.DeleteOrgCompanyEngagementRequest.
 * Use `create(DeleteOrgCompanyEngagementRequestSchema)` to create a new message.
 */
export const DeleteOrgCompanyEngagementRequestSchema: GenMessage<DeleteOrgCompanyEngagementRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 10);

/**
 * @generated from message inventory.v1.DeleteOrgCompanyEngagementResponse
 */
export type DeleteOrgCompanyEngagementResponse = Message<"inventory.v1.DeleteOrgCompanyEngagementResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteOrgCompanyEngagementResponse.
 * Use `create(DeleteOrgCompanyEngagementResponseSchema)` to create a new message.
 */
export const DeleteOrgCompanyEngagementResponseSchema: GenMessage<DeleteOrgCompanyEngagementResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 11);

/**
 * @generated from message inventory.v1.DeleteOrgCompanyRequest
 */
export type DeleteOrgCompanyRequest = Message<"inventory.v1.DeleteOrgCompanyRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message inventory.v1.DeleteOrgCompanyRequest.
 * Use `create(DeleteOrgCompanyRequestSchema)` to create a new message.
 */
export const DeleteOrgCompanyRequestSchema: GenMessage<DeleteOrgCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 12);

/**
 * @generated from message inventory.v1.DeleteOrgCompanyResponse
 */
export type DeleteOrgCompanyResponse = Message<"inventory.v1.DeleteOrgCompanyResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteOrgCompanyResponse.
 * Use `create(DeleteOrgCompanyResponseSchema)` to create a new message.
 */
export const DeleteOrgCompanyResponseSchema: GenMessage<DeleteOrgCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 13);

/**
 * @generated from message inventory.v1.AutocompleteCompanyRequest
 */
export type AutocompleteCompanyRequest = Message<"inventory.v1.AutocompleteCompanyRequest"> & {
  /**
   * @generated from field: string search = 1;
   */
  search: string;
};

/**
 * Describes the message inventory.v1.AutocompleteCompanyRequest.
 * Use `create(AutocompleteCompanyRequestSchema)` to create a new message.
 */
export const AutocompleteCompanyRequestSchema: GenMessage<AutocompleteCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 14);

/**
 * @generated from message inventory.v1.AutocompleteItem
 */
export type AutocompleteItem = Message<"inventory.v1.AutocompleteItem"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string domain = 2;
   */
  domain: string;

  /**
   * @generated from field: string industry = 3;
   */
  industry: string;

  /**
   * @generated from field: string company_size = 4;
   */
  companySize: string;

  /**
   * @generated from field: optional string pdl_id = 5;
   */
  pdlId?: string;

  /**
   * @generated from field: optional inventory.v1.CompanyStatus status = 6;
   */
  status?: CompanyStatus;

  /**
   * @generated from field: optional string company_id = 7;
   */
  companyId?: string;

  /**
   * @generated from field: optional string org_company_id = 8;
   */
  orgCompanyId?: string;

  /**
   * @generated from field: optional inventory.v1.CompanyLifecycle lifecycle = 9;
   */
  lifecycle?: CompanyLifecycle;

  /**
   * @generated from field: repeated inventory.v1.EngagementAutocompleteItem engagements = 10;
   */
  engagements: EngagementAutocompleteItem[];
};

/**
 * Describes the message inventory.v1.AutocompleteItem.
 * Use `create(AutocompleteItemSchema)` to create a new message.
 */
export const AutocompleteItemSchema: GenMessage<AutocompleteItem> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 15);

/**
 * @generated from message inventory.v1.EngagementAutocompleteItem
 */
export type EngagementAutocompleteItem = Message<"inventory.v1.EngagementAutocompleteItem"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Set when the caller's org has an engagement linked to this product.
   * Unset otherwise. A product can be linked to at most one company per org.
   *
   * @generated from field: optional inventory.v1.EngagementLink link = 5;
   */
  link?: EngagementLink;

  /**
   * LLM-written one-liner; unset until the product is enriched.
   *
   * @generated from field: optional string short_description = 6;
   */
  shortDescription?: string;
};

/**
 * Describes the message inventory.v1.EngagementAutocompleteItem.
 * Use `create(EngagementAutocompleteItemSchema)` to create a new message.
 */
export const EngagementAutocompleteItemSchema: GenMessage<EngagementAutocompleteItem> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 16);

/**
 * @generated from message inventory.v1.EngagementLink
 */
export type EngagementLink = Message<"inventory.v1.EngagementLink"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: string org_company_engagement_id = 2;
   */
  orgCompanyEngagementId: string;
};

/**
 * Describes the message inventory.v1.EngagementLink.
 * Use `create(EngagementLinkSchema)` to create a new message.
 */
export const EngagementLinkSchema: GenMessage<EngagementLink> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 17);

/**
 * @generated from message inventory.v1.AutocompleteCompanyResponse
 */
export type AutocompleteCompanyResponse = Message<"inventory.v1.AutocompleteCompanyResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AutocompleteItem items = 1;
   */
  items: AutocompleteItem[];
};

/**
 * Describes the message inventory.v1.AutocompleteCompanyResponse.
 * Use `create(AutocompleteCompanyResponseSchema)` to create a new message.
 */
export const AutocompleteCompanyResponseSchema: GenMessage<AutocompleteCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 18);

/**
 * @generated from message inventory.v1.CreateCompanyRequest
 */
export type CreateCompanyRequest = Message<"inventory.v1.CreateCompanyRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional inventory.v1.CompanyStatus status = 2;
   */
  status?: CompanyStatus;

  /**
   * @generated from field: inventory.v1.CompanyLifecycle lifecycle = 3;
   */
  lifecycle: CompanyLifecycle;

  /**
   * @generated from field: optional string website = 4;
   */
  website?: string;

  /**
   * @generated from field: optional string company_id = 5;
   */
  companyId?: string;

  /**
   * @generated from field: optional string pdl_id = 6;
   */
  pdlId?: string;

  /**
   * @generated from field: bool is_manual = 7;
   */
  isManual: boolean;

  /**
   * @generated from field: bool is_business_owner_request = 8;
   */
  isBusinessOwnerRequest: boolean;

  /**
   * @generated from field: optional string parent_id = 9;
   */
  parentId?: string;
};

/**
 * Describes the message inventory.v1.CreateCompanyRequest.
 * Use `create(CreateCompanyRequestSchema)` to create a new message.
 */
export const CreateCompanyRequestSchema: GenMessage<CreateCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 19);

/**
 * @generated from message inventory.v1.CreateCompanyResponse
 */
export type CreateCompanyResponse = Message<"inventory.v1.CreateCompanyResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateCompanyResponse.
 * Use `create(CreateCompanyResponseSchema)` to create a new message.
 */
export const CreateCompanyResponseSchema: GenMessage<CreateCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 20);

/**
 * @generated from message inventory.v1.CreateBusinessOwnerRequest
 */
export type CreateBusinessOwnerRequest = Message<"inventory.v1.CreateBusinessOwnerRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message inventory.v1.CreateBusinessOwnerRequest.
 * Use `create(CreateBusinessOwnerRequestSchema)` to create a new message.
 */
export const CreateBusinessOwnerRequestSchema: GenMessage<CreateBusinessOwnerRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 21);

/**
 * @generated from message inventory.v1.CreateBusinessOwnerResponse
 */
export type CreateBusinessOwnerResponse = Message<"inventory.v1.CreateBusinessOwnerResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateBusinessOwnerResponse.
 * Use `create(CreateBusinessOwnerResponseSchema)` to create a new message.
 */
export const CreateBusinessOwnerResponseSchema: GenMessage<CreateBusinessOwnerResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 22);

/**
 * @generated from message inventory.v1.UpdateBusinessOwnerRequest
 */
export type UpdateBusinessOwnerRequest = Message<"inventory.v1.UpdateBusinessOwnerRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * if not set, we will unset the business owner
   *
   * @generated from field: optional string business_owner_id = 2;
   */
  businessOwnerId?: string;
};

/**
 * Describes the message inventory.v1.UpdateBusinessOwnerRequest.
 * Use `create(UpdateBusinessOwnerRequestSchema)` to create a new message.
 */
export const UpdateBusinessOwnerRequestSchema: GenMessage<UpdateBusinessOwnerRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 23);

/**
 * @generated from message inventory.v1.UpdateBusinessOwnerResponse
 */
export type UpdateBusinessOwnerResponse = Message<"inventory.v1.UpdateBusinessOwnerResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateBusinessOwnerResponse.
 * Use `create(UpdateBusinessOwnerResponseSchema)` to create a new message.
 */
export const UpdateBusinessOwnerResponseSchema: GenMessage<UpdateBusinessOwnerResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 24);

/**
 * @generated from message inventory.v1.AutocompleteBusinessOwnerRequest
 */
export type AutocompleteBusinessOwnerRequest = Message<"inventory.v1.AutocompleteBusinessOwnerRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string search = 2;
   */
  search: string;
};

/**
 * Describes the message inventory.v1.AutocompleteBusinessOwnerRequest.
 * Use `create(AutocompleteBusinessOwnerRequestSchema)` to create a new message.
 */
export const AutocompleteBusinessOwnerRequestSchema: GenMessage<AutocompleteBusinessOwnerRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 25);

/**
 * @generated from message inventory.v1.AutocompleteBusinessOwnerResponse
 */
export type AutocompleteBusinessOwnerResponse = Message<"inventory.v1.AutocompleteBusinessOwnerResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.BusinessOwner business_owners = 1;
   */
  businessOwners: BusinessOwner[];
};

/**
 * Describes the message inventory.v1.AutocompleteBusinessOwnerResponse.
 * Use `create(AutocompleteBusinessOwnerResponseSchema)` to create a new message.
 */
export const AutocompleteBusinessOwnerResponseSchema: GenMessage<AutocompleteBusinessOwnerResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 26);

/**
 * @generated from message inventory.v1.ListInherentRiskCategoriesRequest
 */
export type ListInherentRiskCategoriesRequest = Message<"inventory.v1.ListInherentRiskCategoriesRequest"> & {
};

/**
 * Describes the message inventory.v1.ListInherentRiskCategoriesRequest.
 * Use `create(ListInherentRiskCategoriesRequestSchema)` to create a new message.
 */
export const ListInherentRiskCategoriesRequestSchema: GenMessage<ListInherentRiskCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 27);

/**
 * @generated from message inventory.v1.ListInherentRiskCategoriesResponse
 */
export type ListInherentRiskCategoriesResponse = Message<"inventory.v1.ListInherentRiskCategoriesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.InherentRiskCategory categories = 1;
   */
  categories: InherentRiskCategory[];

  /**
   * @generated from field: repeated inventory.v1.InherentRiskCategoryDisplayOrder category_display_orders = 2;
   */
  categoryDisplayOrders: InherentRiskCategoryDisplayOrder[];
};

/**
 * Describes the message inventory.v1.ListInherentRiskCategoriesResponse.
 * Use `create(ListInherentRiskCategoriesResponseSchema)` to create a new message.
 */
export const ListInherentRiskCategoriesResponseSchema: GenMessage<ListInherentRiskCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 28);

/**
 * @generated from message inventory.v1.InherentRiskCategoryDisplayOrder
 */
export type InherentRiskCategoryDisplayOrder = Message<"inventory.v1.InherentRiskCategoryDisplayOrder"> & {
  /**
   * @generated from field: string category = 1;
   */
  category: string;

  /**
   * @generated from field: int32 display_order = 2;
   */
  displayOrder: number;
};

/**
 * Describes the message inventory.v1.InherentRiskCategoryDisplayOrder.
 * Use `create(InherentRiskCategoryDisplayOrderSchema)` to create a new message.
 */
export const InherentRiskCategoryDisplayOrderSchema: GenMessage<InherentRiskCategoryDisplayOrder> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 29);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.IRQAnswer
 */
export type IRQAnswer = Message<"inventory.v1.IRQAnswer"> & {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId: string;

  /**
   * @generated from field: repeated string selected_option_ids = 2;
   */
  selectedOptionIds: string[];

  /**
   * @generated from field: optional string content = 3;
   */
  content?: string;
};

/**
 * Describes the message inventory.v1.IRQAnswer.
 * Use `create(IRQAnswerSchema)` to create a new message.
 */
export const IRQAnswerSchema: GenMessage<IRQAnswer> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 30);

/**
 * @generated from message inventory.v1.SetIRQRequest
 */
export type SetIRQRequest = Message<"inventory.v1.SetIRQRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: optional string org_company_engagement_id = 2;
   */
  orgCompanyEngagementId?: string;

  /**
   * @generated from field: repeated inventory.v1.IRQAnswer answers = 3;
   */
  answers: IRQAnswer[];

  /**
   * @generated from field: optional string integration_source = 4;
   */
  integrationSource?: string;
};

/**
 * Describes the message inventory.v1.SetIRQRequest.
 * Use `create(SetIRQRequestSchema)` to create a new message.
 */
export const SetIRQRequestSchema: GenMessage<SetIRQRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 31);

/**
 * @generated from message inventory.v1.SetIRQResponse
 */
export type SetIRQResponse = Message<"inventory.v1.SetIRQResponse"> & {
};

/**
 * Describes the message inventory.v1.SetIRQResponse.
 * Use `create(SetIRQResponseSchema)` to create a new message.
 */
export const SetIRQResponseSchema: GenMessage<SetIRQResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 32);

/**
 * @generated from message inventory.v1.ListCompaniesRequest
 */
export type ListCompaniesRequest = Message<"inventory.v1.ListCompaniesRequest"> & {
};

/**
 * Describes the message inventory.v1.ListCompaniesRequest.
 * Use `create(ListCompaniesRequestSchema)` to create a new message.
 */
export const ListCompaniesRequestSchema: GenMessage<ListCompaniesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 33);

/**
 * @generated from message inventory.v1.ListCompaniesResponse
 */
export type ListCompaniesResponse = Message<"inventory.v1.ListCompaniesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Company companies = 1;
   */
  companies: Company[];
};

/**
 * Describes the message inventory.v1.ListCompaniesResponse.
 * Use `create(ListCompaniesResponseSchema)` to create a new message.
 */
export const ListCompaniesResponseSchema: GenMessage<ListCompaniesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 34);

/**
 * DiscoverySolution is a solution awaiting a connect/dismiss decision (org_company_id is nil).
 * State is derived from dismissed_at: dismissed when set, otherwise pending.
 *
 * @generated from message inventory.v1.DiscoverySolution
 */
export type DiscoverySolution = Message<"inventory.v1.DiscoverySolution"> & {
  /**
   * org_solution id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated inventory.v1.Source sources = 3;
   */
  sources: Source[];

  /**
   * @generated from field: repeated inventory.v1.Permission permissions = 4;
   */
  permissions: Permission[];

  /**
   * @generated from field: int64 users_count = 5;
   */
  usersCount: bigint;

  /**
   * @generated from field: int64 total_users_count = 6;
   */
  totalUsersCount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp dismissed_at = 8;
   */
  dismissedAt?: Timestamp;

  /**
   * @generated from field: optional string dismissed_by_user_id = 9;
   */
  dismissedByUserId?: string;

  /**
   * @generated from field: optional inventory.v1.SuggestedThirdParty suggested_third_party = 10;
   */
  suggestedThirdParty?: SuggestedThirdParty;

  /**
   * @generated from field: repeated customer.management.v1.User assignees = 11;
   */
  assignees: User$1[];

  /**
   * devices_count is how many endpoints the app is installed on, from endpoint sources like
   * CrowdStrike. Zero for identity-only sources, which measure reach in users instead.
   *
   * @generated from field: int64 devices_count = 12;
   */
  devicesCount: bigint;

  /**
   * cloud_account_counts is how many cloud accounts the app was found in, per classification.
   * Empty for solutions with no cloud source and for those found in no account.
   *
   * @generated from field: repeated inventory.v1.SolutionCloudAccountCount cloud_account_counts = 13;
   */
  cloudAccountCounts: SolutionCloudAccountCount[];
};

/**
 * Describes the message inventory.v1.DiscoverySolution.
 * Use `create(DiscoverySolutionSchema)` to create a new message.
 */
export const DiscoverySolutionSchema: GenMessage<DiscoverySolution> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 35);

/**
 * SolutionCloudAccountCount is how many distinct cloud accounts of one classification an app was
 * found in, whatever the hosting kind.
 *
 * @generated from message inventory.v1.SolutionCloudAccountCount
 */
export type SolutionCloudAccountCount = Message<"inventory.v1.SolutionCloudAccountCount"> & {
  /**
   * @generated from field: inventory.v1.CloudAccountClassification classification = 1;
   */
  classification: CloudAccountClassification;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message inventory.v1.SolutionCloudAccountCount.
 * Use `create(SolutionCloudAccountCountSchema)` to create a new message.
 */
export const SolutionCloudAccountCountSchema: GenMessage<SolutionCloudAccountCount> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 36);

/**
 * @generated from message inventory.v1.SuggestedThirdParty
 */
export type SuggestedThirdParty = Message<"inventory.v1.SuggestedThirdParty"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * set iff the suggestion is an inventory match
   *
   * @generated from field: optional string org_company_id = 2;
   */
  orgCompanyId?: string;

  /**
   * @generated from field: optional string domain = 3;
   */
  domain?: string;

  /**
   * @generated from field: optional string industry = 4;
   */
  industry?: string;

  /**
   * set iff the suggestion is a resolved catalog company with no inventory org-company yet
   *
   * @generated from field: optional string company_id = 5;
   */
  companyId?: string;

  /**
   * @generated from field: optional string company_size = 6;
   */
  companySize?: string;

  /**
   * @generated from field: optional string short_description = 7;
   */
  shortDescription?: string;

  /**
   * @generated from field: inventory.v1.AIPosture ai_posture = 8;
   */
  aiPosture: AIPosture;
};

/**
 * Describes the message inventory.v1.SuggestedThirdParty.
 * Use `create(SuggestedThirdPartySchema)` to create a new message.
 */
export const SuggestedThirdPartySchema: GenMessage<SuggestedThirdParty> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 37);

/**
 * @generated from message inventory.v1.ListDiscoverySolutionsRequest
 */
export type ListDiscoverySolutionsRequest = Message<"inventory.v1.ListDiscoverySolutionsRequest"> & {
  /**
   * @generated from field: bool include_dismissed = 1;
   */
  includeDismissed: boolean;
};

/**
 * Describes the message inventory.v1.ListDiscoverySolutionsRequest.
 * Use `create(ListDiscoverySolutionsRequestSchema)` to create a new message.
 */
export const ListDiscoverySolutionsRequestSchema: GenMessage<ListDiscoverySolutionsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 38);

/**
 * @generated from message inventory.v1.ListDiscoverySolutionsResponse
 */
export type ListDiscoverySolutionsResponse = Message<"inventory.v1.ListDiscoverySolutionsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.DiscoverySolution solutions = 1;
   */
  solutions: DiscoverySolution[];
};

/**
 * Describes the message inventory.v1.ListDiscoverySolutionsResponse.
 * Use `create(ListDiscoverySolutionsResponseSchema)` to create a new message.
 */
export const ListDiscoverySolutionsResponseSchema: GenMessage<ListDiscoverySolutionsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 39);

/**
 * @generated from message inventory.v1.SetSolutionDismissedRequest
 */
export type SetSolutionDismissedRequest = Message<"inventory.v1.SetSolutionDismissedRequest"> & {
  /**
   * org_solution id
   *
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;

  /**
   * @generated from field: bool dismissed = 2;
   */
  dismissed: boolean;
};

/**
 * Describes the message inventory.v1.SetSolutionDismissedRequest.
 * Use `create(SetSolutionDismissedRequestSchema)` to create a new message.
 */
export const SetSolutionDismissedRequestSchema: GenMessage<SetSolutionDismissedRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 40);

/**
 * @generated from message inventory.v1.SetSolutionDismissedResponse
 */
export type SetSolutionDismissedResponse = Message<"inventory.v1.SetSolutionDismissedResponse"> & {
};

/**
 * Describes the message inventory.v1.SetSolutionDismissedResponse.
 * Use `create(SetSolutionDismissedResponseSchema)` to create a new message.
 */
export const SetSolutionDismissedResponseSchema: GenMessage<SetSolutionDismissedResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 41);

/**
 * @generated from message inventory.v1.SetSolutionSuggestedThirdPartyRequest
 */
export type SetSolutionSuggestedThirdPartyRequest = Message<"inventory.v1.SetSolutionSuggestedThirdPartyRequest"> & {
  /**
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;

  /**
   * @generated from field: optional string org_company_id = 2;
   */
  orgCompanyId?: string;
};

/**
 * Describes the message inventory.v1.SetSolutionSuggestedThirdPartyRequest.
 * Use `create(SetSolutionSuggestedThirdPartyRequestSchema)` to create a new message.
 */
export const SetSolutionSuggestedThirdPartyRequestSchema: GenMessage<SetSolutionSuggestedThirdPartyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 42);

/**
 * @generated from message inventory.v1.SetSolutionSuggestedThirdPartyResponse
 */
export type SetSolutionSuggestedThirdPartyResponse = Message<"inventory.v1.SetSolutionSuggestedThirdPartyResponse"> & {
  /**
   * @generated from field: optional inventory.v1.SuggestedThirdParty suggested_third_party = 1;
   */
  suggestedThirdParty?: SuggestedThirdParty;
};

/**
 * Describes the message inventory.v1.SetSolutionSuggestedThirdPartyResponse.
 * Use `create(SetSolutionSuggestedThirdPartyResponseSchema)` to create a new message.
 */
export const SetSolutionSuggestedThirdPartyResponseSchema: GenMessage<SetSolutionSuggestedThirdPartyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 43);

/**
 * @generated from message inventory.v1.AddSolutionAssigneeRequest
 */
export type AddSolutionAssigneeRequest = Message<"inventory.v1.AddSolutionAssigneeRequest"> & {
  /**
   * org_solution id
   *
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.AddSolutionAssigneeRequest.
 * Use `create(AddSolutionAssigneeRequestSchema)` to create a new message.
 */
export const AddSolutionAssigneeRequestSchema: GenMessage<AddSolutionAssigneeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 44);

/**
 * @generated from message inventory.v1.AddSolutionAssigneeResponse
 */
export type AddSolutionAssigneeResponse = Message<"inventory.v1.AddSolutionAssigneeResponse"> & {
};

/**
 * Describes the message inventory.v1.AddSolutionAssigneeResponse.
 * Use `create(AddSolutionAssigneeResponseSchema)` to create a new message.
 */
export const AddSolutionAssigneeResponseSchema: GenMessage<AddSolutionAssigneeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 45);

/**
 * @generated from message inventory.v1.RemoveSolutionAssigneeRequest
 */
export type RemoveSolutionAssigneeRequest = Message<"inventory.v1.RemoveSolutionAssigneeRequest"> & {
  /**
   * org_solution id
   *
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.RemoveSolutionAssigneeRequest.
 * Use `create(RemoveSolutionAssigneeRequestSchema)` to create a new message.
 */
export const RemoveSolutionAssigneeRequestSchema: GenMessage<RemoveSolutionAssigneeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 46);

/**
 * @generated from message inventory.v1.RemoveSolutionAssigneeResponse
 */
export type RemoveSolutionAssigneeResponse = Message<"inventory.v1.RemoveSolutionAssigneeResponse"> & {
};

/**
 * Describes the message inventory.v1.RemoveSolutionAssigneeResponse.
 * Use `create(RemoveSolutionAssigneeResponseSchema)` to create a new message.
 */
export const RemoveSolutionAssigneeResponseSchema: GenMessage<RemoveSolutionAssigneeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 47);

/**
 * GetDiscoverySolutionRequest fetches drawer detail (usage + permissions) for a single
 * unlinked discovery solution.
 *
 * @generated from message inventory.v1.GetDiscoverySolutionRequest
 */
export type GetDiscoverySolutionRequest = Message<"inventory.v1.GetDiscoverySolutionRequest"> & {
  /**
   * org_solution id
   *
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;

  /**
   * @generated from field: bool with_users = 2;
   */
  withUsers: boolean;
};

/**
 * Describes the message inventory.v1.GetDiscoverySolutionRequest.
 * Use `create(GetDiscoverySolutionRequestSchema)` to create a new message.
 */
export const GetDiscoverySolutionRequestSchema: GenMessage<GetDiscoverySolutionRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 48);

/**
 * @generated from message inventory.v1.GetDiscoverySolutionResponse
 */
export type GetDiscoverySolutionResponse = Message<"inventory.v1.GetDiscoverySolutionResponse"> & {
  /**
   * @generated from field: int32 num_users = 1;
   */
  numUsers: number;

  /**
   * @generated from field: map<string, int32> num_users_by_organization_unit = 2;
   */
  numUsersByOrganizationUnit: { [key: string]: number };

  /**
   * @generated from field: repeated inventory.v1.DataTypeInfo data_types = 3;
   */
  dataTypes: DataTypeInfo[];

  /**
   * @generated from field: repeated inventory.v1.Permission permissions = 4;
   */
  permissions: Permission[];

  /**
   * @generated from field: repeated inventory.v1.User users = 5;
   */
  users: User[];

  /**
   * @generated from field: optional inventory.v1.SuggestedThirdParty suggested_third_party = 6;
   */
  suggestedThirdParty?: SuggestedThirdParty;
};

/**
 * Describes the message inventory.v1.GetDiscoverySolutionResponse.
 * Use `create(GetDiscoverySolutionResponseSchema)` to create a new message.
 */
export const GetDiscoverySolutionResponseSchema: GenMessage<GetDiscoverySolutionResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 49);

/**
 * @generated from message inventory.v1.ListSolutionDevicesRequest
 */
export type ListSolutionDevicesRequest = Message<"inventory.v1.ListSolutionDevicesRequest"> & {
  /**
   * org_solution id
   *
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;
};

/**
 * Describes the message inventory.v1.ListSolutionDevicesRequest.
 * Use `create(ListSolutionDevicesRequestSchema)` to create a new message.
 */
export const ListSolutionDevicesRequestSchema: GenMessage<ListSolutionDevicesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 50);

/**
 * @generated from message inventory.v1.ListSolutionDevicesResponse
 */
export type ListSolutionDevicesResponse = Message<"inventory.v1.ListSolutionDevicesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.SolutionDevice devices = 1;
   */
  devices: SolutionDevice[];
};

/**
 * Describes the message inventory.v1.ListSolutionDevicesResponse.
 * Use `create(ListSolutionDevicesResponseSchema)` to create a new message.
 */
export const ListSolutionDevicesResponseSchema: GenMessage<ListSolutionDevicesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 51);

/**
 * SolutionDevice is one endpoint a discovery solution is installed on.
 *
 * @generated from message inventory.v1.SolutionDevice
 */
export type SolutionDevice = Message<"inventory.v1.SolutionDevice"> & {
  /**
   * org_host id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string hostname = 2;
   */
  hostname: string;

  /**
   * device_type and os_platform mirror the normalized host enums: device_type is one of
   * unknown/workstation/server/domain_controller, os_platform one of unknown/windows/mac/linux.
   *
   * @generated from field: string device_type = 3;
   */
  deviceType: string;

  /**
   * @generated from field: string os_platform = 4;
   */
  osPlatform: string;

  /**
   * os_version is the vendor-reported OS string, e.g. "Windows Server 2019"; empty when unreported.
   *
   * @generated from field: string os_version = 5;
   */
  osVersion: string;

  /**
   * last_used is when the app was last used on this device, not when the device was last seen.
   * Unset when the source does not report a usage time.
   *
   * @generated from field: optional google.protobuf.Timestamp last_used = 6;
   */
  lastUsed?: Timestamp;

  /**
   * permissions are the scopes the solution showed on this device, from its observed access.
   *
   * @generated from field: repeated inventory.v1.Permission permissions = 7;
   */
  permissions: Permission[];
};

/**
 * Describes the message inventory.v1.SolutionDevice.
 * Use `create(SolutionDeviceSchema)` to create a new message.
 */
export const SolutionDeviceSchema: GenMessage<SolutionDevice> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 52);

/**
 * @generated from message inventory.v1.ListSolutionCloudAccountsRequest
 */
export type ListSolutionCloudAccountsRequest = Message<"inventory.v1.ListSolutionCloudAccountsRequest"> & {
  /**
   * org_solution id
   *
   * @generated from field: string solution_id = 1;
   */
  solutionId: string;
};

/**
 * Describes the message inventory.v1.ListSolutionCloudAccountsRequest.
 * Use `create(ListSolutionCloudAccountsRequestSchema)` to create a new message.
 */
export const ListSolutionCloudAccountsRequestSchema: GenMessage<ListSolutionCloudAccountsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 53);

/**
 * @generated from message inventory.v1.ListSolutionCloudAccountsResponse
 */
export type ListSolutionCloudAccountsResponse = Message<"inventory.v1.ListSolutionCloudAccountsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.SolutionCloudAccount cloud_accounts = 1;
   */
  cloudAccounts: SolutionCloudAccount[];
};

/**
 * Describes the message inventory.v1.ListSolutionCloudAccountsResponse.
 * Use `create(ListSolutionCloudAccountsResponseSchema)` to create a new message.
 */
export const ListSolutionCloudAccountsResponseSchema: GenMessage<ListSolutionCloudAccountsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 54);

/**
 * SolutionCloudAccount is one cloud account a discovery solution was found in.
 *
 * @generated from message inventory.v1.SolutionCloudAccount
 */
export type SolutionCloudAccount = Message<"inventory.v1.SolutionCloudAccount"> & {
  /**
   * @generated from field: string org_cloud_account_id = 1;
   */
  orgCloudAccountId: string;

  /**
   * @generated from field: string cloud_platform = 2;
   */
  cloudPlatform: string;

  /**
   * account_id is the id the cloud provider gave the account.
   *
   * @generated from field: string account_id = 3;
   */
  accountId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: inventory.v1.CloudAccountClassification auto_classification = 5;
   */
  autoClassification: CloudAccountClassification;

  /**
   * @generated from field: optional inventory.v1.CloudAccountClassification classification_override = 6;
   */
  classificationOverride?: CloudAccountClassification;

  /**
   * effective_classification is the override when set, otherwise the automatic value.
   *
   * @generated from field: inventory.v1.CloudAccountClassification effective_classification = 7;
   */
  effectiveClassification: CloudAccountClassification;

  /**
   * ou_path is the organizational units the account sits under, root excluded, nearest unit last.
   *
   * @generated from field: repeated string ou_path = 8;
   */
  ouPath: string[];

  /**
   * solution_count is how many detected applications the organization has in this account.
   *
   * @generated from field: int32 solution_count = 9;
   */
  solutionCount: number;

  /**
   * sole_classification_solution_count is how many of those applications have this as their only
   * account of its effective classification, so reclassifying it moves them out of that segment.
   *
   * @generated from field: int32 sole_classification_solution_count = 10;
   */
  soleClassificationSolutionCount: number;
};

/**
 * Describes the message inventory.v1.SolutionCloudAccount.
 * Use `create(SolutionCloudAccountSchema)` to create a new message.
 */
export const SolutionCloudAccountSchema: GenMessage<SolutionCloudAccount> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 55);

/**
 * @generated from message inventory.v1.SetCloudAccountClassificationRequest
 */
export type SetCloudAccountClassificationRequest = Message<"inventory.v1.SetCloudAccountClassificationRequest"> & {
  /**
   * @generated from field: string org_cloud_account_id = 1;
   */
  orgCloudAccountId: string;

  /**
   * absent clears the override
   *
   * @generated from field: optional inventory.v1.CloudAccountClassification classification = 2;
   */
  classification?: CloudAccountClassification;
};

/**
 * Describes the message inventory.v1.SetCloudAccountClassificationRequest.
 * Use `create(SetCloudAccountClassificationRequestSchema)` to create a new message.
 */
export const SetCloudAccountClassificationRequestSchema: GenMessage<SetCloudAccountClassificationRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 56);

/**
 * @generated from message inventory.v1.SetCloudAccountClassificationResponse
 */
export type SetCloudAccountClassificationResponse = Message<"inventory.v1.SetCloudAccountClassificationResponse"> & {
};

/**
 * Describes the message inventory.v1.SetCloudAccountClassificationResponse.
 * Use `create(SetCloudAccountClassificationResponseSchema)` to create a new message.
 */
export const SetCloudAccountClassificationResponseSchema: GenMessage<SetCloudAccountClassificationResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 57);

/**
 * @generated from message inventory.v1.ListCompaniesDataTypesRequest
 */
export type ListCompaniesDataTypesRequest = Message<"inventory.v1.ListCompaniesDataTypesRequest"> & {
};

/**
 * Describes the message inventory.v1.ListCompaniesDataTypesRequest.
 * Use `create(ListCompaniesDataTypesRequestSchema)` to create a new message.
 */
export const ListCompaniesDataTypesRequestSchema: GenMessage<ListCompaniesDataTypesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 58);

/**
 * @generated from message inventory.v1.DataTypeInfos
 */
export type DataTypeInfos = Message<"inventory.v1.DataTypeInfos"> & {
  /**
   * @generated from field: repeated inventory.v1.DataTypeInfo data_types = 1;
   */
  dataTypes: DataTypeInfo[];
};

/**
 * Describes the message inventory.v1.DataTypeInfos.
 * Use `create(DataTypeInfosSchema)` to create a new message.
 */
export const DataTypeInfosSchema: GenMessage<DataTypeInfos> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 59);

/**
 * @generated from message inventory.v1.ListCompaniesDataTypesResponse
 */
export type ListCompaniesDataTypesResponse = Message<"inventory.v1.ListCompaniesDataTypesResponse"> & {
  /**
   * @generated from field: map<string, inventory.v1.DataTypeInfos> companies_data_types = 1;
   */
  companiesDataTypes: { [key: string]: DataTypeInfos };
};

/**
 * Describes the message inventory.v1.ListCompaniesDataTypesResponse.
 * Use `create(ListCompaniesDataTypesResponseSchema)` to create a new message.
 */
export const ListCompaniesDataTypesResponseSchema: GenMessage<ListCompaniesDataTypesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 60);

/**
 * @generated from message inventory.v1.GetCompanyRequest
 */
export type GetCompanyRequest = Message<"inventory.v1.GetCompanyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.GetCompanyRequest.
 * Use `create(GetCompanyRequestSchema)` to create a new message.
 */
export const GetCompanyRequestSchema: GenMessage<GetCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 61);

/**
 * @generated from message inventory.v1.GetCompanyResponse
 */
export type GetCompanyResponse = Message<"inventory.v1.GetCompanyResponse"> & {
  /**
   * @generated from field: inventory.v1.Company company = 1;
   */
  company?: Company;
};

/**
 * Describes the message inventory.v1.GetCompanyResponse.
 * Use `create(GetCompanyResponseSchema)` to create a new message.
 */
export const GetCompanyResponseSchema: GenMessage<GetCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 62);

/**
 * @generated from message inventory.v1.GetCompanyDrawerMetadataRequest
 */
export type GetCompanyDrawerMetadataRequest = Message<"inventory.v1.GetCompanyDrawerMetadataRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: optional string solution_id = 2;
   */
  solutionId?: string;

  /**
   * @generated from field: bool with_users = 3;
   */
  withUsers: boolean;
};

/**
 * Describes the message inventory.v1.GetCompanyDrawerMetadataRequest.
 * Use `create(GetCompanyDrawerMetadataRequestSchema)` to create a new message.
 */
export const GetCompanyDrawerMetadataRequestSchema: GenMessage<GetCompanyDrawerMetadataRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 63);

/**
 * @generated from message inventory.v1.PointOfContact
 */
export type PointOfContact = Message<"inventory.v1.PointOfContact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: optional string role = 4;
   */
  role?: string;

  /**
   * @generated from field: bool active = 5;
   */
  active: boolean;

  /**
   * @generated from field: optional inventory.v1.Source source = 6;
   */
  source?: Source;
};

/**
 * Describes the message inventory.v1.PointOfContact.
 * Use `create(PointOfContactSchema)` to create a new message.
 */
export const PointOfContactSchema: GenMessage<PointOfContact> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 64);

/**
 * @generated from message inventory.v1.GetPointsOfContactRequest
 */
export type GetPointsOfContactRequest = Message<"inventory.v1.GetPointsOfContactRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;
};

/**
 * Describes the message inventory.v1.GetPointsOfContactRequest.
 * Use `create(GetPointsOfContactRequestSchema)` to create a new message.
 */
export const GetPointsOfContactRequestSchema: GenMessage<GetPointsOfContactRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 65);

/**
 * @generated from message inventory.v1.GetPointsOfContactResponse
 */
export type GetPointsOfContactResponse = Message<"inventory.v1.GetPointsOfContactResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.PointOfContact point_of_contacts = 1;
   */
  pointOfContacts: PointOfContact[];
};

/**
 * Describes the message inventory.v1.GetPointsOfContactResponse.
 * Use `create(GetPointsOfContactResponseSchema)` to create a new message.
 */
export const GetPointsOfContactResponseSchema: GenMessage<GetPointsOfContactResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 66);

/**
 * @generated from message inventory.v1.GetPointsOfContactsByCompanyRequest
 */
export type GetPointsOfContactsByCompanyRequest = Message<"inventory.v1.GetPointsOfContactsByCompanyRequest"> & {
};

/**
 * Describes the message inventory.v1.GetPointsOfContactsByCompanyRequest.
 * Use `create(GetPointsOfContactsByCompanyRequestSchema)` to create a new message.
 */
export const GetPointsOfContactsByCompanyRequestSchema: GenMessage<GetPointsOfContactsByCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 67);

/**
 * @generated from message inventory.v1.GetPointsOfContactsByCompanyResponse
 */
export type GetPointsOfContactsByCompanyResponse = Message<"inventory.v1.GetPointsOfContactsByCompanyResponse"> & {
  /**
   * @generated from field: map<string, inventory.v1.PointOfContactList> points_of_contact_by_company = 1;
   */
  pointsOfContactByCompany: { [key: string]: PointOfContactList };
};

/**
 * Describes the message inventory.v1.GetPointsOfContactsByCompanyResponse.
 * Use `create(GetPointsOfContactsByCompanyResponseSchema)` to create a new message.
 */
export const GetPointsOfContactsByCompanyResponseSchema: GenMessage<GetPointsOfContactsByCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 68);

/**
 * @generated from message inventory.v1.PointOfContactList
 */
export type PointOfContactList = Message<"inventory.v1.PointOfContactList"> & {
  /**
   * @generated from field: repeated inventory.v1.PointOfContact point_of_contacts = 1;
   */
  pointOfContacts: PointOfContact[];
};

/**
 * Describes the message inventory.v1.PointOfContactList.
 * Use `create(PointOfContactListSchema)` to create a new message.
 */
export const PointOfContactListSchema: GenMessage<PointOfContactList> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 69);

/**
 * @generated from message inventory.v1.UpdatePointOfContactRequest
 */
export type UpdatePointOfContactRequest = Message<"inventory.v1.UpdatePointOfContactRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * @generated from field: optional inventory.v1.PointOfContact point_of_contact = 2;
   */
  pointOfContact?: PointOfContact;

  /**
   * @generated from field: inventory.v1.PointOfContactChangeType change_type = 3;
   */
  changeType: PointOfContactChangeType;

  /**
   * @generated from field: bool skip_change_log = 4;
   */
  skipChangeLog: boolean;
};

/**
 * Describes the message inventory.v1.UpdatePointOfContactRequest.
 * Use `create(UpdatePointOfContactRequestSchema)` to create a new message.
 */
export const UpdatePointOfContactRequestSchema: GenMessage<UpdatePointOfContactRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 70);

/**
 * @generated from message inventory.v1.UpdatePointOfContactResponse
 */
export type UpdatePointOfContactResponse = Message<"inventory.v1.UpdatePointOfContactResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdatePointOfContactResponse.
 * Use `create(UpdatePointOfContactResponseSchema)` to create a new message.
 */
export const UpdatePointOfContactResponseSchema: GenMessage<UpdatePointOfContactResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 71);

/**
 * @generated from message inventory.v1.BusinessOwner
 */
export type BusinessOwner = Message<"inventory.v1.BusinessOwner"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_request_at = 4;
   */
  lastRequestAt?: Timestamp;

  /**
   * @generated from field: optional inventory.v1.Source source = 5;
   */
  source?: Source;
};

/**
 * Describes the message inventory.v1.BusinessOwner.
 * Use `create(BusinessOwnerSchema)` to create a new message.
 */
export const BusinessOwnerSchema: GenMessage<BusinessOwner> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 72);

/**
 * @generated from message inventory.v1.User
 */
export type User = Message<"inventory.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_seen = 5;
   */
  lastSeen?: Timestamp;

  /**
   * @generated from field: repeated inventory.v1.Source sources = 6;
   */
  sources: Source[];
};

/**
 * Describes the message inventory.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 73);

/**
 * @generated from message inventory.v1.Parent
 */
export type Parent = Message<"inventory.v1.Parent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.Parent.
 * Use `create(ParentSchema)` to create a new message.
 */
export const ParentSchema: GenMessage<Parent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 74);

/**
 * @generated from message inventory.v1.Subsidiary
 */
export type Subsidiary = Message<"inventory.v1.Subsidiary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: inventory.v1.CompanyLifecycle lifecycle = 4;
   */
  lifecycle: CompanyLifecycle;

  /**
   * @generated from field: assessment.v1.AssessmentScore assessment_score = 5;
   */
  assessmentScore: AssessmentScore;

  /**
   * @generated from field: repeated string tag_ids = 6;
   */
  tagIds: string[];

  /**
   * @generated from field: repeated inventory.v1.AlertCountStat alerts_by_level = 7;
   */
  alertsByLevel: AlertCountStat[];

  /**
   * @generated from field: repeated inventory.v1.DataTypeInfo data_types = 8;
   */
  dataTypes: DataTypeInfo[];

  /**
   * @generated from field: optional inventory.v1.RiskLevel validated_risk = 10;
   */
  validatedRisk?: RiskLevel;

  /**
   * @generated from field: inventory.v1.RiskLevel calculated_risk = 11;
   */
  calculatedRisk: RiskLevel;
};

/**
 * Describes the message inventory.v1.Subsidiary.
 * Use `create(SubsidiarySchema)` to create a new message.
 */
export const SubsidiarySchema: GenMessage<Subsidiary> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 75);

/**
 * @generated from message inventory.v1.GetCompanyDrawerMetadataResponse
 */
export type GetCompanyDrawerMetadataResponse = Message<"inventory.v1.GetCompanyDrawerMetadataResponse"> & {
  /**
   * these fields change depending on the given solution_id
   *
   * @generated from field: int32 num_users = 1;
   */
  numUsers: number;

  /**
   * @generated from field: map<string, int32> num_users_by_organization_unit = 2;
   */
  numUsersByOrganizationUnit: { [key: string]: number };

  /**
   * @generated from field: repeated inventory.v1.DataTypeInfo data_types = 3;
   */
  dataTypes: DataTypeInfo[];

  /**
   * @generated from field: repeated inventory.v1.Permission permissions = 4;
   */
  permissions: Permission[];

  /**
   * @generated from field: repeated inventory.v1.Asset assets = 5;
   */
  assets: Asset[];

  /**
   * @generated from field: repeated inventory.v1.User users = 6;
   */
  users: User[];

  /**
   * @generated from field: repeated inventory.v1.Solution solutions = 7;
   */
  solutions: Solution[];

  /**
   * @generated from field: optional inventory.v1.BusinessOwner business_owner = 8;
   */
  businessOwner?: BusinessOwner;

  /**
   * @generated from field: repeated inventory.v1.IRQCategorySeverity irq_category_severities = 9;
   */
  irqCategorySeverities: IRQCategorySeverity[];

  /**
   * @generated from field: bool is_irq_template_outdated = 10;
   */
  isIrqTemplateOutdated: boolean;

  /**
   * @generated from field: repeated inventory.v1.Subsidiary subsidiaries = 11;
   */
  subsidiaries: Subsidiary[];
};

/**
 * Describes the message inventory.v1.GetCompanyDrawerMetadataResponse.
 * Use `create(GetCompanyDrawerMetadataResponseSchema)` to create a new message.
 */
export const GetCompanyDrawerMetadataResponseSchema: GenMessage<GetCompanyDrawerMetadataResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 76);

/**
 * @generated from message inventory.v1.UpdateCompanyRequest
 */
export type UpdateCompanyRequest = Message<"inventory.v1.UpdateCompanyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional inventory.v1.CompanyStatus status = 2;
   */
  status?: CompanyStatus;

  /**
   * @generated from field: optional string comment = 3;
   */
  comment?: string;

  /**
   * @generated from field: optional bool engagement_mode = 4;
   */
  engagementMode?: boolean;

  /**
   * @generated from field: optional string questionnaire_contact_email = 5;
   */
  questionnaireContactEmail?: string;

  /**
   * @generated from field: optional inventory.v1.CompanyLifecycle lifecycle = 6;
   */
  lifecycle?: CompanyLifecycle;

  /**
   * @generated from field: optional string parent_id = 8;
   */
  parentId?: string;
};

/**
 * Describes the message inventory.v1.UpdateCompanyRequest.
 * Use `create(UpdateCompanyRequestSchema)` to create a new message.
 */
export const UpdateCompanyRequestSchema: GenMessage<UpdateCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 77);

/**
 * @generated from message inventory.v1.UpdateCompanyResponse
 */
export type UpdateCompanyResponse = Message<"inventory.v1.UpdateCompanyResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateCompanyResponse.
 * Use `create(UpdateCompanyResponseSchema)` to create a new message.
 */
export const UpdateCompanyResponseSchema: GenMessage<UpdateCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 78);

/**
 * @generated from message inventory.v1.UpdateCompanyInherentRiskRequest
 */
export type UpdateCompanyInherentRiskRequest = Message<"inventory.v1.UpdateCompanyInherentRiskRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 2;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: optional string comment = 3;
   */
  comment?: string;
};

/**
 * Describes the message inventory.v1.UpdateCompanyInherentRiskRequest.
 * Use `create(UpdateCompanyInherentRiskRequestSchema)` to create a new message.
 */
export const UpdateCompanyInherentRiskRequestSchema: GenMessage<UpdateCompanyInherentRiskRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 79);

/**
 * @generated from message inventory.v1.UpdateCompanyInherentRiskResponse
 */
export type UpdateCompanyInherentRiskResponse = Message<"inventory.v1.UpdateCompanyInherentRiskResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateCompanyInherentRiskResponse.
 * Use `create(UpdateCompanyInherentRiskResponseSchema)` to create a new message.
 */
export const UpdateCompanyInherentRiskResponseSchema: GenMessage<UpdateCompanyInherentRiskResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 80);

/**
 * @generated from message inventory.v1.GetInherentRiskRequest
 */
export type GetInherentRiskRequest = Message<"inventory.v1.GetInherentRiskRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: optional string org_company_engagement_id = 2;
   */
  orgCompanyEngagementId?: string;
};

/**
 * Describes the message inventory.v1.GetInherentRiskRequest.
 * Use `create(GetInherentRiskRequestSchema)` to create a new message.
 */
export const GetInherentRiskRequestSchema: GenMessage<GetInherentRiskRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 81);

/**
 * @generated from message inventory.v1.GetInherentRiskResponse
 */
export type GetInherentRiskResponse = Message<"inventory.v1.GetInherentRiskResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.InherentRiskGroup inherent_risk_groups = 1;
   */
  inherentRiskGroups: InherentRiskGroup[];

  /**
   * @generated from field: repeated inventory.v1.InherentRiskCategoryDisplayOrder category_display_orders = 2;
   */
  categoryDisplayOrders: InherentRiskCategoryDisplayOrder[];

  /**
   * @generated from field: bool is_template_outdated = 3;
   */
  isTemplateOutdated: boolean;
};

/**
 * Describes the message inventory.v1.GetInherentRiskResponse.
 * Use `create(GetInherentRiskResponseSchema)` to create a new message.
 */
export const GetInherentRiskResponseSchema: GenMessage<GetInherentRiskResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 82);

/**
 * @generated from message inventory.v1.GetCompanyActivityLogRequest
 */
export type GetCompanyActivityLogRequest = Message<"inventory.v1.GetCompanyActivityLogRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;
};

/**
 * Describes the message inventory.v1.GetCompanyActivityLogRequest.
 * Use `create(GetCompanyActivityLogRequestSchema)` to create a new message.
 */
export const GetCompanyActivityLogRequestSchema: GenMessage<GetCompanyActivityLogRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 83);

/**
 * @generated from message inventory.v1.GetCompanyActivityLogResponse
 */
export type GetCompanyActivityLogResponse = Message<"inventory.v1.GetCompanyActivityLogResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.CompanyActivityLogItem items = 1;
   */
  items: CompanyActivityLogItem[];
};

/**
 * Describes the message inventory.v1.GetCompanyActivityLogResponse.
 * Use `create(GetCompanyActivityLogResponseSchema)` to create a new message.
 */
export const GetCompanyActivityLogResponseSchema: GenMessage<GetCompanyActivityLogResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 84);

/**
 * @generated from message inventory.v1.OrgCompanyEngagement
 */
export type OrgCompanyEngagement = Message<"inventory.v1.OrgCompanyEngagement"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: inventory.v1.RiskLevel calculated_risk_level = 4;
   */
  calculatedRiskLevel: RiskLevel;

  /**
   * @generated from field: repeated inventory.v1.CustomFieldValue custom_field_values = 6;
   */
  customFieldValues: CustomFieldValue[];

  /**
   * @generated from field: repeated inventory.v1.PointOfContact point_of_contacts = 7;
   */
  pointOfContacts: PointOfContact[];

  /**
   * @generated from field: optional inventory.v1.BusinessOwner business_owner = 8;
   */
  businessOwner?: BusinessOwner;

  /**
   * @generated from field: repeated inventory.v1.Tag tags = 9;
   */
  tags: Tag[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string org_company_id = 12;
   */
  orgCompanyId: string;

  /**
   * @generated from field: string third_party_name = 13;
   */
  thirdPartyName: string;

  /**
   * @generated from field: repeated inventory.v1.InherentRiskGroup inherent_risk_groups = 14;
   */
  inherentRiskGroups: InherentRiskGroup[];

  /**
   * @generated from field: repeated inventory.v1.InherentRiskCategoryDisplayOrder category_display_orders = 15;
   */
  categoryDisplayOrders: InherentRiskCategoryDisplayOrder[];

  /**
   * @generated from field: map<string, inventory.v1.InherentRiskCategoryValues> inherent_risk_categories_by_category = 16;
   */
  inherentRiskCategoriesByCategory: { [key: string]: InherentRiskCategoryValues };

  /**
   * @generated from field: repeated inventory.v1.IRQCategorySeverity irq_category_severities = 17;
   */
  irqCategorySeverities: IRQCategorySeverity[];

  /**
   * @generated from field: bool is_irq_template_outdated = 18;
   */
  isIrqTemplateOutdated: boolean;

  /**
   * @generated from field: optional inventory.v1.RiskLevel company_validated_risk = 19;
   */
  companyValidatedRisk?: RiskLevel;

  /**
   * @generated from field: inventory.v1.RiskLevel company_calculated_risk = 20;
   */
  companyCalculatedRisk: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.RiskLevel validated_risk_level = 21;
   */
  validatedRiskLevel?: RiskLevel;

  /**
   * The linked product's descriptions. Set by GetEngagement and GetCompany only, when a product is linked.
   *
   * @generated from field: optional string product_description = 22;
   */
  productDescription?: string;

  /**
   * @generated from field: optional string product_short_description = 23;
   */
  productShortDescription?: string;
};

/**
 * Describes the message inventory.v1.OrgCompanyEngagement.
 * Use `create(OrgCompanyEngagementSchema)` to create a new message.
 */
export const OrgCompanyEngagementSchema: GenMessage<OrgCompanyEngagement> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 85);

/**
 * @generated from message inventory.v1.OrgCompanyEngagementChange
 */
export type OrgCompanyEngagementChange = Message<"inventory.v1.OrgCompanyEngagementChange"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: optional inventory.v1.RiskLevel calculated_risk_level = 3;
   */
  calculatedRiskLevel?: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.RiskLevel prev_inherent_risk = 4;
   */
  prevInherentRisk?: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.RiskLevel new_inherent_risk = 5;
   */
  newInherentRisk?: RiskLevel;
};

/**
 * Describes the message inventory.v1.OrgCompanyEngagementChange.
 * Use `create(OrgCompanyEngagementChangeSchema)` to create a new message.
 */
export const OrgCompanyEngagementChangeSchema: GenMessage<OrgCompanyEngagementChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 86);

/**
 * @generated from message inventory.v1.OrgCompanyEngagementChangeLog
 */
export type OrgCompanyEngagementChangeLog = Message<"inventory.v1.OrgCompanyEngagementChangeLog"> & {
  /**
   * @generated from field: inventory.v1.OrgCompanyEngagementChangeType change_type = 1;
   */
  changeType: OrgCompanyEngagementChangeType;

  /**
   * @generated from field: optional inventory.v1.OrgCompanyEngagementChange engagement = 2;
   */
  engagement?: OrgCompanyEngagementChange;

  /**
   * @generated from field: string org_company_engagement_id = 3;
   */
  orgCompanyEngagementId: string;

  /**
   * @generated from field: string org_company_engagement_name = 4;
   */
  orgCompanyEngagementName: string;
};

/**
 * Describes the message inventory.v1.OrgCompanyEngagementChangeLog.
 * Use `create(OrgCompanyEngagementChangeLogSchema)` to create a new message.
 */
export const OrgCompanyEngagementChangeLogSchema: GenMessage<OrgCompanyEngagementChangeLog> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 87);

/**
 * @generated from message inventory.v1.Solution
 */
export type Solution = Message<"inventory.v1.Solution"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated inventory.v1.Source sources = 3;
   */
  sources: Source[];

  /**
   * @generated from field: repeated inventory.v1.Permission permissions = 8;
   */
  permissions: Permission[];

  /**
   * @generated from field: int64 users_count = 9;
   */
  usersCount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int64 total_users_count = 11;
   */
  totalUsersCount: bigint;
};

/**
 * Describes the message inventory.v1.Solution.
 * Use `create(SolutionSchema)` to create a new message.
 */
export const SolutionSchema: GenMessage<Solution> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 88);

/**
 * @generated from message inventory.v1.Company
 */
export type Company = Message<"inventory.v1.Company"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.CompanyProfile profile = 2;
   */
  profile?: CompanyProfile;

  /**
   * @generated from field: inventory.v1.CompanyStatus status = 4;
   */
  status: CompanyStatus;

  /**
   * @generated from field: google.protobuf.Timestamp status_last_update = 5;
   */
  statusLastUpdate?: Timestamp;

  /**
   * @generated from field: string spend = 7;
   */
  spend: string;

  /**
   * @generated from field: repeated inventory.v1.AlertCountStat alerts_by_level = 8;
   */
  alertsByLevel: AlertCountStat[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: repeated inventory.v1.Solution solutions = 14;
   */
  solutions: Solution[];

  /**
   * @generated from field: repeated inventory.v1.Source sources = 16;
   */
  sources: Source[];

  /**
   * @generated from field: inventory.v1.RiskLevel calculated_risk = 17;
   */
  calculatedRisk: RiskLevel;

  /**
   * @generated from field: bool is_subprocessor = 18;
   */
  isSubprocessor: boolean;

  /**
   * @generated from field: int32 total_questionnaires = 22;
   */
  totalQuestionnaires: number;

  /**
   * @generated from field: int32 total_ongoing_questionnaires = 23;
   */
  totalOngoingQuestionnaires: number;

  /**
   * @generated from field: repeated string ongoing_projects_ids = 24;
   */
  ongoingProjectsIds: string[];

  /**
   * @generated from field: repeated string tag_ids = 25;
   */
  tagIds: string[];

  /**
   * @generated from field: repeated string country_codes = 27;
   */
  countryCodes: string[];

  /**
   * @generated from field: repeated inventory.v1.CustomFieldValue custom_field_values = 28;
   */
  customFieldValues: CustomFieldValue[];

  /**
   * @generated from field: repeated inventory.v1.OrgCompanyEngagement org_company_engagements = 29;
   */
  orgCompanyEngagements: OrgCompanyEngagement[];

  /**
   * @generated from field: bool engagement_mode = 30;
   */
  engagementMode: boolean;

  /**
   * @generated from field: optional inventory.v1.ReAssessmentDueDate re_assessment_due_date = 31;
   */
  reAssessmentDueDate?: ReAssessmentDueDate;

  /**
   * @generated from field: repeated string recipients_emails = 32;
   */
  recipientsEmails: string[];

  /**
   * @generated from field: optional string questionnaire_contact_email = 33;
   */
  questionnaireContactEmail?: string;

  /**
   * @generated from field: inventory.v1.CompanyLifecycle lifecycle = 34;
   */
  lifecycle: CompanyLifecycle;

  /**
   * @generated from field: map<string, inventory.v1.InherentRiskCategoryValues> inherent_risk_categories_by_category = 35;
   */
  inherentRiskCategoriesByCategory: { [key: string]: InherentRiskCategoryValues };

  /**
   * @generated from field: assessment.v1.AssessmentScore assessment_score = 37;
   */
  assessmentScore: AssessmentScore;

  /**
   * @generated from field: optional google.protobuf.Timestamp portal_last_cadence_reminder_at = 39;
   */
  portalLastCadenceReminderAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp portal_next_reminder_at = 40;
   */
  portalNextReminderAt?: Timestamp;

  /**
   * @generated from field: optional inventory.v1.BusinessOwner business_owner = 41;
   */
  businessOwner?: BusinessOwner;

  /**
   * @generated from field: optional inventory.v1.Parent parent = 42;
   */
  parent?: Parent;

  /**
   * @generated from field: optional inventory.v1.RiskLevel validated_risk = 43;
   */
  validatedRisk?: RiskLevel;

  /**
   * Identifier of the actor who last set the inherent risk — a customer user_id
   * when the risk was validated, or "Lema" when computed by the calculator.
   *
   * @generated from field: optional string inherent_risk_updated_by = 44;
   */
  inherentRiskUpdatedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp inherent_risk_updated_at = 45;
   */
  inherentRiskUpdatedAt?: Timestamp;

  /**
   * Unset => the vendor has no AI classification at all.
   *
   * @generated from field: optional inventory.v1.CompanyAIProfile ai_profile = 47;
   */
  aiProfile?: CompanyAIProfile;
};

/**
 * Describes the message inventory.v1.Company.
 * Use `create(CompanySchema)` to create a new message.
 */
export const CompanySchema: GenMessage<Company> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 89);

/**
 * @generated from message inventory.v1.ReAssessmentDueDate
 */
export type ReAssessmentDueDate = Message<"inventory.v1.ReAssessmentDueDate"> & {
  /**
   * @generated from field: google.protobuf.Timestamp due_date = 1;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: inventory.v1.ReAssessmentDueDateUpdateType update_type = 2;
   */
  updateType: ReAssessmentDueDateUpdateType;

  /**
   * @generated from field: optional string user_id = 3;
   */
  userId?: string;

  /**
   * @generated from field: optional google.protobuf.Duration cadence = 4;
   */
  cadence?: Duration;
};

/**
 * Describes the message inventory.v1.ReAssessmentDueDate.
 * Use `create(ReAssessmentDueDateSchema)` to create a new message.
 */
export const ReAssessmentDueDateSchema: GenMessage<ReAssessmentDueDate> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 90);

/**
 * @generated from message inventory.v1.IRQCategorySeverity
 */
export type IRQCategorySeverity = Message<"inventory.v1.IRQCategorySeverity"> & {
  /**
   * @generated from field: string category = 1;
   */
  category: string;

  /**
   * @generated from field: inventory.v1.RiskLevel severity = 2;
   */
  severity: RiskLevel;
};

/**
 * Describes the message inventory.v1.IRQCategorySeverity.
 * Use `create(IRQCategorySeveritySchema)` to create a new message.
 */
export const IRQCategorySeveritySchema: GenMessage<IRQCategorySeverity> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 91);

/**
 * @generated from message inventory.v1.InherentRiskCategoryValues
 */
export type InherentRiskCategoryValues = Message<"inventory.v1.InherentRiskCategoryValues"> & {
  /**
   * @generated from field: repeated string values = 1;
   */
  values: string[];
};

/**
 * Describes the message inventory.v1.InherentRiskCategoryValues.
 * Use `create(InherentRiskCategoryValuesSchema)` to create a new message.
 */
export const InherentRiskCategoryValuesSchema: GenMessage<InherentRiskCategoryValues> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 92);

/**
 * @generated from message inventory.v1.CustomFieldDateValue
 */
export type CustomFieldDateValue = Message<"inventory.v1.CustomFieldDateValue"> & {
  /**
   * @generated from field: string custom_field_id = 1;
   */
  customFieldId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp value = 2;
   */
  value?: Timestamp;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.CustomFieldDateValue.
 * Use `create(CustomFieldDateValueSchema)` to create a new message.
 */
export const CustomFieldDateValueSchema: GenMessage<CustomFieldDateValue> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 93);

/**
 * @generated from message inventory.v1.CustomFieldFreeTextValue
 */
export type CustomFieldFreeTextValue = Message<"inventory.v1.CustomFieldFreeTextValue"> & {
  /**
   * @generated from field: string custom_field_id = 1;
   */
  customFieldId: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.CustomFieldFreeTextValue.
 * Use `create(CustomFieldFreeTextValueSchema)` to create a new message.
 */
export const CustomFieldFreeTextValueSchema: GenMessage<CustomFieldFreeTextValue> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 94);

/**
 * @generated from message inventory.v1.CustomFieldMultiSelectValue
 */
export type CustomFieldMultiSelectValue = Message<"inventory.v1.CustomFieldMultiSelectValue"> & {
  /**
   * @generated from field: string custom_field_id = 1;
   */
  customFieldId: string;

  /**
   * @generated from field: repeated inventory.v1.Option selected_options = 2;
   */
  selectedOptions: Option[];

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.CustomFieldMultiSelectValue.
 * Use `create(CustomFieldMultiSelectValueSchema)` to create a new message.
 */
export const CustomFieldMultiSelectValueSchema: GenMessage<CustomFieldMultiSelectValue> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 95);

/**
 * @generated from message inventory.v1.CustomFieldValue
 */
export type CustomFieldValue = Message<"inventory.v1.CustomFieldValue"> & {
  /**
   * @generated from oneof inventory.v1.CustomFieldValue.value
   */
  value: {
    /**
     * @generated from field: inventory.v1.CustomFieldFreeTextValue free_text_value = 1;
     */
    value: CustomFieldFreeTextValue;
    case: "freeTextValue";
  } | {
    /**
     * @generated from field: inventory.v1.CustomFieldMultiSelectValue multi_select_value = 2;
     */
    value: CustomFieldMultiSelectValue;
    case: "multiSelectValue";
  } | {
    /**
     * @generated from field: inventory.v1.CustomFieldDateValue date_value = 3;
     */
    value: CustomFieldDateValue;
    case: "dateValue";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.CustomFieldValue.
 * Use `create(CustomFieldValueSchema)` to create a new message.
 */
export const CustomFieldValueSchema: GenMessage<CustomFieldValue> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 96);

/**
 * @generated from message inventory.v1.Permission
 */
export type Permission = Message<"inventory.v1.Permission"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated inventory.v1.PermissionCategory category = 3;
   */
  category: PermissionCategory[];

  /**
   * @generated from field: inventory.v1.Source source = 4;
   */
  source?: Source;
};

/**
 * Describes the message inventory.v1.Permission.
 * Use `create(PermissionSchema)` to create a new message.
 */
export const PermissionSchema: GenMessage<Permission> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 97);

/**
 * @generated from message inventory.v1.CompanyProfile
 */
export type CompanyProfile = Message<"inventory.v1.CompanyProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string short_description = 3;
   */
  shortDescription: string;

  /**
   * @generated from field: string long_description = 4;
   */
  longDescription: string;

  /**
   * @generated from field: int32 founding_year = 5;
   */
  foundingYear: number;

  /**
   * @generated from field: int32 total_funding = 6;
   */
  totalFunding: number;

  /**
   * @generated from field: string industry_sector = 7;
   */
  industrySector: string;

  /**
   * @generated from field: string website = 8;
   */
  website: string;

  /**
   * @generated from field: string linkedin_url = 9;
   */
  linkedinUrl: string;

  /**
   * @generated from field: string company_size = 11;
   */
  companySize: string;

  /**
   * @generated from field: string paragraph_description = 12;
   */
  paragraphDescription: string;

  /**
   * stock market ticker if public
   *
   * @generated from field: string ticker = 13;
   */
  ticker: string;
};

/**
 * Describes the message inventory.v1.CompanyProfile.
 * Use `create(CompanyProfileSchema)` to create a new message.
 */
export const CompanyProfileSchema: GenMessage<CompanyProfile> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 98);

/**
 * @generated from message inventory.v1.Asset
 */
export type Asset = Message<"inventory.v1.Asset"> & {
  /**
   * @generated from field: string asset = 1;
   */
  asset: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];

  /**
   * @generated from field: string details = 4;
   */
  details: string;

  /**
   * @generated from field: string country_name = 5;
   */
  countryName: string;

  /**
   * @generated from field: string country_code = 6;
   */
  countryCode: string;
};

/**
 * Describes the message inventory.v1.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema: GenMessage<Asset> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 99);

/**
 * @generated from message inventory.v1.InherentRiskGroup
 */
export type InherentRiskGroup = Message<"inventory.v1.InherentRiskGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: optional string subcategory = 3;
   */
  subcategory?: string;

  /**
   * @generated from field: string question = 4;
   */
  question: string;

  /**
   * @generated from field: inventory.v1.InherentRiskQuestionType type = 5;
   */
  type: InherentRiskQuestionType;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;

  /**
   * @generated from field: repeated inventory.v1.InherentRiskItem inherent_risk_items = 7;
   */
  inherentRiskItems: InherentRiskItem[];

  /**
   * @generated from field: inventory.v1.InherentRiskCategoryEnum category_enum = 8;
   */
  categoryEnum: InherentRiskCategoryEnum;

  /**
   * @generated from field: optional inventory.v1.TemplateBuilderCondition condition = 9;
   */
  condition?: TemplateBuilderCondition;

  /**
   * @generated from field: optional string description = 10;
   */
  description?: string;
};

/**
 * Describes the message inventory.v1.InherentRiskGroup.
 * Use `create(InherentRiskGroupSchema)` to create a new message.
 */
export const InherentRiskGroupSchema: GenMessage<InherentRiskGroup> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 100);

/**
 * @generated from message inventory.v1.InherentRiskCategory
 */
export type InherentRiskCategory = Message<"inventory.v1.InherentRiskCategory"> & {
  /**
   * @generated from field: inventory.v1.InherentRiskCategoryEnum category_enum = 1;
   */
  categoryEnum: InherentRiskCategoryEnum;

  /**
   * @generated from field: repeated inventory.v1.InherentRiskItem items = 2;
   */
  items: InherentRiskItem[];

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: string question = 4;
   */
  question: string;

  /**
   * @generated from field: int32 display_order = 5;
   */
  displayOrder: number;

  /**
   * @generated from field: inventory.v1.InherentRiskQuestionType type = 6;
   */
  type: InherentRiskQuestionType;

  /**
   * @generated from field: string id = 7;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.InherentRiskCategory.
 * Use `create(InherentRiskCategorySchema)` to create a new message.
 */
export const InherentRiskCategorySchema: GenMessage<InherentRiskCategory> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 101);

/**
 * @generated from message inventory.v1.InherentRiskItem
 */
export type InherentRiskItem = Message<"inventory.v1.InherentRiskItem"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel severity = 1;
   */
  severity: RiskLevel;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: inventory.v1.InherentRiskSource source = 3;
   */
  source: InherentRiskSource;

  /**
   * @generated from field: optional string id = 4;
   */
  id?: string;

  /**
   * @generated from field: optional inventory.v1.Source integration_source = 5;
   */
  integrationSource?: Source;

  /**
   * @generated from field: repeated inventory.v1.Permission permissions = 6;
   */
  permissions: Permission[];

  /**
   * @generated from field: optional string explanation = 7;
   */
  explanation?: string;

  /**
   * @generated from field: bool enabled = 8;
   */
  enabled: boolean;

  /**
   * For FREE_TEXT questions, this carries the saved answer content
   *
   * @generated from field: optional string content = 9;
   */
  content?: string;

  /**
   * @generated from field: repeated inventory.v1.Scope scopes = 10;
   */
  scopes: Scope[];

  /**
   * @generated from field: repeated string evidence_quotes = 11;
   */
  evidenceQuotes: string[];
};

/**
 * Describes the message inventory.v1.InherentRiskItem.
 * Use `create(InherentRiskItemSchema)` to create a new message.
 */
export const InherentRiskItemSchema: GenMessage<InherentRiskItem> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 102);

/**
 * @generated from message inventory.v1.CompanyActivityLogItem
 */
export type CompanyActivityLogItem = Message<"inventory.v1.CompanyActivityLogItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp time = 2;
   */
  time?: Timestamp;

  /**
   * @generated from field: optional inventory.v1.Comment comment = 3;
   */
  comment?: Comment;

  /**
   * @generated from field: optional string user_id = 4;
   */
  userId?: string;

  /**
   * @generated from oneof inventory.v1.CompanyActivityLogItem.activity_log_item
   */
  activityLogItem: {
    /**
     * @generated from field: inventory.v1.CompanyRiskChange risk_change = 5;
     */
    value: CompanyRiskChange;
    case: "riskChange";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyStatusChange status_change = 6;
     */
    value: CompanyStatusChange;
    case: "statusChange";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyInherentRiskItemAdded inherent_risk_item_added = 7;
     */
    value: CompanyInherentRiskItemAdded;
    case: "inherentRiskItemAdded";
  } | {
    /**
     * @generated from field: inventory.v1.IRQUpdate irq_update = 8;
     */
    value: IRQUpdate;
    case: "irqUpdate";
  } | {
    /**
     * @generated from field: inventory.v1.AlertAdded alert_added = 9;
     */
    value: AlertAdded;
    case: "alertAdded";
  } | {
    /**
     * @generated from field: inventory.v1.AlertStatusChange alert_status_change = 10;
     */
    value: AlertStatusChange;
    case: "alertStatusChange";
  } | {
    /**
     * @generated from field: inventory.v1.AlertSeverityChange alert_severity_change = 11;
     */
    value: AlertSeverityChange;
    case: "alertSeverityChange";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyCreated company_created = 12;
     */
    value: CompanyCreated;
    case: "companyCreated";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyBusinessOwnerChange business_owner_change = 13;
     */
    value: CompanyBusinessOwnerChange;
    case: "businessOwnerChange";
  } | {
    /**
     * @generated from field: inventory.v1.AssessmentFinished assessment_finished = 14;
     */
    value: AssessmentFinished;
    case: "assessmentFinished";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyPointOfContactChange point_of_contact_change = 15;
     */
    value: CompanyPointOfContactChange;
    case: "pointOfContactChange";
  } | {
    /**
     * @generated from field: inventory.v1.CustomFieldMultiSelectOptionChange custom_field_multi_select_option_change = 16;
     */
    value: CustomFieldMultiSelectOptionChange;
    case: "customFieldMultiSelectOptionChange";
  } | {
    /**
     * @generated from field: inventory.v1.CustomFieldFreeTextUpdated custom_field_free_text_updated = 17;
     */
    value: CustomFieldFreeTextUpdated;
    case: "customFieldFreeTextUpdated";
  } | {
    /**
     * @generated from field: inventory.v1.CustomFieldDateUpdated custom_field_date_updated = 18;
     */
    value: CustomFieldDateUpdated;
    case: "customFieldDateUpdated";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyEngagementModeChange engagement_mode_change = 19;
     */
    value: CompanyEngagementModeChange;
    case: "engagementModeChange";
  } | {
    /**
     * @generated from field: inventory.v1.OrgCompanyEngagementChangeLog org_company_engagement_change_log = 20;
     */
    value: OrgCompanyEngagementChangeLog;
    case: "orgCompanyEngagementChangeLog";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyEngagementInherentRiskItemAdded engagement_inherent_risk_item_added = 21;
     */
    value: CompanyEngagementInherentRiskItemAdded;
    case: "engagementInherentRiskItemAdded";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyLifecycleChange lifecycle_change = 22;
     */
    value: CompanyLifecycleChange;
    case: "lifecycleChange";
  } | {
    /**
     * @generated from field: inventory.v1.ReAssessmentDueDateChange re_assessment_due_date_change = 23;
     */
    value: ReAssessmentDueDateChange;
    case: "reAssessmentDueDateChange";
  } | {
    /**
     * @generated from field: inventory.v1.CompanyAssessmentScoreChange assessment_score_change = 24;
     */
    value: CompanyAssessmentScoreChange;
    case: "assessmentScoreChange";
  } | {
    /**
     * @generated from field: inventory.v1.AssessmentCreated assessment_created = 27;
     */
    value: AssessmentCreated;
    case: "assessmentCreated";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional inventory.v1.User user = 25;
   */
  user?: User;

  /**
   * Set when the entry was driven by an inbound integration rather than a
   * user; UI renders the integration's logo/name in place of a user avatar.
   *
   * @generated from field: optional inventory.v1.Source integration_source = 26;
   */
  integrationSource?: Source;
};

/**
 * Describes the message inventory.v1.CompanyActivityLogItem.
 * Use `create(CompanyActivityLogItemSchema)` to create a new message.
 */
export const CompanyActivityLogItemSchema: GenMessage<CompanyActivityLogItem> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 103);

/**
 * @generated from message inventory.v1.CompanyAssessmentScoreChange
 */
export type CompanyAssessmentScoreChange = Message<"inventory.v1.CompanyAssessmentScoreChange"> & {
  /**
   * @generated from field: assessment.v1.AssessmentScore prev_assessment_score = 1;
   */
  prevAssessmentScore: AssessmentScore;

  /**
   * @generated from field: assessment.v1.AssessmentScore new_assessment_score = 2;
   */
  newAssessmentScore: AssessmentScore;
};

/**
 * Describes the message inventory.v1.CompanyAssessmentScoreChange.
 * Use `create(CompanyAssessmentScoreChangeSchema)` to create a new message.
 */
export const CompanyAssessmentScoreChangeSchema: GenMessage<CompanyAssessmentScoreChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 104);

/**
 * @generated from message inventory.v1.ReAssessmentDueDateChange
 */
export type ReAssessmentDueDateChange = Message<"inventory.v1.ReAssessmentDueDateChange"> & {
  /**
   * @generated from field: inventory.v1.ReAssessmentDueDate prev_re_assessment_due_date = 1;
   */
  prevReAssessmentDueDate?: ReAssessmentDueDate;

  /**
   * @generated from field: inventory.v1.ReAssessmentDueDate new_re_assessment_due_date = 2;
   */
  newReAssessmentDueDate?: ReAssessmentDueDate;
};

/**
 * Describes the message inventory.v1.ReAssessmentDueDateChange.
 * Use `create(ReAssessmentDueDateChangeSchema)` to create a new message.
 */
export const ReAssessmentDueDateChangeSchema: GenMessage<ReAssessmentDueDateChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 105);

/**
 * @generated from message inventory.v1.CompanyLifecycleChange
 */
export type CompanyLifecycleChange = Message<"inventory.v1.CompanyLifecycleChange"> & {
  /**
   * @generated from field: inventory.v1.CompanyLifecycle prev_lifecycle = 2;
   */
  prevLifecycle: CompanyLifecycle;

  /**
   * @generated from field: inventory.v1.CompanyLifecycle new_lifecycle = 3;
   */
  newLifecycle: CompanyLifecycle;
};

/**
 * Describes the message inventory.v1.CompanyLifecycleChange.
 * Use `create(CompanyLifecycleChangeSchema)` to create a new message.
 */
export const CompanyLifecycleChangeSchema: GenMessage<CompanyLifecycleChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 106);

/**
 * @generated from message inventory.v1.AssessmentFinished
 */
export type AssessmentFinished = Message<"inventory.v1.AssessmentFinished"> & {
  /**
   * @generated from field: string project_name = 1;
   */
  projectName: string;

  /**
   * @generated from field: inventory.v1.AssessmentDecision decision = 2;
   */
  decision: AssessmentDecision;
};

/**
 * Describes the message inventory.v1.AssessmentFinished.
 * Use `create(AssessmentFinishedSchema)` to create a new message.
 */
export const AssessmentFinishedSchema: GenMessage<AssessmentFinished> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 107);

/**
 * @generated from message inventory.v1.AssessmentCreated
 */
export type AssessmentCreated = Message<"inventory.v1.AssessmentCreated"> & {
  /**
   * @generated from field: string project_name = 1;
   */
  projectName: string;
};

/**
 * Describes the message inventory.v1.AssessmentCreated.
 * Use `create(AssessmentCreatedSchema)` to create a new message.
 */
export const AssessmentCreatedSchema: GenMessage<AssessmentCreated> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 108);

/**
 * @generated from message inventory.v1.CustomFieldMultiSelectOptionChange
 */
export type CustomFieldMultiSelectOptionChange = Message<"inventory.v1.CustomFieldMultiSelectOptionChange"> & {
  /**
   * @generated from field: string field_name = 1;
   */
  fieldName: string;

  /**
   * @generated from field: string option_name = 2;
   */
  optionName: string;

  /**
   * @generated from field: inventory.v1.CustomFieldMultiSelectOptionChangeType change_type = 3;
   */
  changeType: CustomFieldMultiSelectOptionChangeType;
};

/**
 * Describes the message inventory.v1.CustomFieldMultiSelectOptionChange.
 * Use `create(CustomFieldMultiSelectOptionChangeSchema)` to create a new message.
 */
export const CustomFieldMultiSelectOptionChangeSchema: GenMessage<CustomFieldMultiSelectOptionChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 109);

/**
 * @generated from message inventory.v1.CustomFieldFreeTextUpdated
 */
export type CustomFieldFreeTextUpdated = Message<"inventory.v1.CustomFieldFreeTextUpdated"> & {
  /**
   * @generated from field: string field_name = 1;
   */
  fieldName: string;

  /**
   * @generated from field: string new_value = 2;
   */
  newValue: string;
};

/**
 * Describes the message inventory.v1.CustomFieldFreeTextUpdated.
 * Use `create(CustomFieldFreeTextUpdatedSchema)` to create a new message.
 */
export const CustomFieldFreeTextUpdatedSchema: GenMessage<CustomFieldFreeTextUpdated> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 110);

/**
 * @generated from message inventory.v1.CustomFieldDateUpdated
 */
export type CustomFieldDateUpdated = Message<"inventory.v1.CustomFieldDateUpdated"> & {
  /**
   * @generated from field: string field_name = 1;
   */
  fieldName: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp new_value = 2;
   */
  newValue?: Timestamp;
};

/**
 * Describes the message inventory.v1.CustomFieldDateUpdated.
 * Use `create(CustomFieldDateUpdatedSchema)` to create a new message.
 */
export const CustomFieldDateUpdatedSchema: GenMessage<CustomFieldDateUpdated> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 111);

/**
 * @generated from message inventory.v1.CompanyPointOfContactChange
 */
export type CompanyPointOfContactChange = Message<"inventory.v1.CompanyPointOfContactChange"> & {
  /**
   * @generated from field: inventory.v1.PointOfContactChangeType change_type = 1;
   */
  changeType: PointOfContactChangeType;

  /**
   * @generated from field: inventory.v1.PointOfContact point_of_contact = 2;
   */
  pointOfContact?: PointOfContact;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.CompanyPointOfContactChange.
 * Use `create(CompanyPointOfContactChangeSchema)` to create a new message.
 */
export const CompanyPointOfContactChangeSchema: GenMessage<CompanyPointOfContactChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 112);

/**
 * @generated from message inventory.v1.CompanyBusinessOwnerChange
 */
export type CompanyBusinessOwnerChange = Message<"inventory.v1.CompanyBusinessOwnerChange"> & {
  /**
   * @generated from field: optional inventory.v1.BusinessOwner prev_business_owner = 1;
   */
  prevBusinessOwner?: BusinessOwner;

  /**
   * @generated from field: optional inventory.v1.BusinessOwner new_business_owner = 2;
   */
  newBusinessOwner?: BusinessOwner;
};

/**
 * Describes the message inventory.v1.CompanyBusinessOwnerChange.
 * Use `create(CompanyBusinessOwnerChangeSchema)` to create a new message.
 */
export const CompanyBusinessOwnerChangeSchema: GenMessage<CompanyBusinessOwnerChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 113);

/**
 * @generated from message inventory.v1.CompanyEngagementModeChange
 */
export type CompanyEngagementModeChange = Message<"inventory.v1.CompanyEngagementModeChange"> & {
  /**
   * @generated from field: bool prev_engagement_mode = 1;
   */
  prevEngagementMode: boolean;

  /**
   * @generated from field: bool new_engagement_mode = 2;
   */
  newEngagementMode: boolean;
};

/**
 * Describes the message inventory.v1.CompanyEngagementModeChange.
 * Use `create(CompanyEngagementModeChangeSchema)` to create a new message.
 */
export const CompanyEngagementModeChangeSchema: GenMessage<CompanyEngagementModeChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 114);

/**
 * @generated from message inventory.v1.IRQUpdate
 */
export type IRQUpdate = Message<"inventory.v1.IRQUpdate"> & {
};

/**
 * Describes the message inventory.v1.IRQUpdate.
 * Use `create(IRQUpdateSchema)` to create a new message.
 */
export const IRQUpdateSchema: GenMessage<IRQUpdate> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 115);

/**
 * @generated from message inventory.v1.CompanyRiskChange
 */
export type CompanyRiskChange = Message<"inventory.v1.CompanyRiskChange"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel prev_inherent_risk = 2;
   */
  prevInherentRisk: RiskLevel;

  /**
   * @generated from field: inventory.v1.RiskLevel new_inherent_risk = 3;
   */
  newInherentRisk: RiskLevel;
};

/**
 * Describes the message inventory.v1.CompanyRiskChange.
 * Use `create(CompanyRiskChangeSchema)` to create a new message.
 */
export const CompanyRiskChangeSchema: GenMessage<CompanyRiskChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 116);

/**
 * @generated from message inventory.v1.CompanyStatusChange
 */
export type CompanyStatusChange = Message<"inventory.v1.CompanyStatusChange"> & {
  /**
   * @generated from field: inventory.v1.CompanyStatus prev_status = 2;
   */
  prevStatus: CompanyStatus;

  /**
   * @generated from field: inventory.v1.CompanyStatus new_status = 3;
   */
  newStatus: CompanyStatus;
};

/**
 * Describes the message inventory.v1.CompanyStatusChange.
 * Use `create(CompanyStatusChangeSchema)` to create a new message.
 */
export const CompanyStatusChangeSchema: GenMessage<CompanyStatusChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 117);

/**
 * @generated from message inventory.v1.CompanyInherentRiskItemAdded
 */
export type CompanyInherentRiskItemAdded = Message<"inventory.v1.CompanyInherentRiskItemAdded"> & {
  /**
   * @generated from field: inventory.v1.InherentRiskItem new_inherent_risk_item = 2;
   */
  newInherentRiskItem?: InherentRiskItem;

  /**
   * @generated from field: inventory.v1.InherentRiskCategoryEnum category_enum = 1;
   */
  categoryEnum: InherentRiskCategoryEnum;

  /**
   * @generated from field: string category_name = 3;
   */
  categoryName: string;
};

/**
 * Describes the message inventory.v1.CompanyInherentRiskItemAdded.
 * Use `create(CompanyInherentRiskItemAddedSchema)` to create a new message.
 */
export const CompanyInherentRiskItemAddedSchema: GenMessage<CompanyInherentRiskItemAdded> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 118);

/**
 * @generated from message inventory.v1.CompanyEngagementInherentRiskItemAdded
 */
export type CompanyEngagementInherentRiskItemAdded = Message<"inventory.v1.CompanyEngagementInherentRiskItemAdded"> & {
  /**
   * @generated from field: string engagement_id = 1;
   */
  engagementId: string;

  /**
   * @generated from field: string engagement_name = 2;
   */
  engagementName: string;

  /**
   * @generated from field: inventory.v1.InherentRiskItem new_inherent_risk_item = 3;
   */
  newInherentRiskItem?: InherentRiskItem;

  /**
   * @generated from field: inventory.v1.InherentRiskCategoryEnum category_enum = 4;
   */
  categoryEnum: InherentRiskCategoryEnum;

  /**
   * @generated from field: string category_name = 5;
   */
  categoryName: string;
};

/**
 * Describes the message inventory.v1.CompanyEngagementInherentRiskItemAdded.
 * Use `create(CompanyEngagementInherentRiskItemAddedSchema)` to create a new message.
 */
export const CompanyEngagementInherentRiskItemAddedSchema: GenMessage<CompanyEngagementInherentRiskItemAdded> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 119);

/**
 * @generated from message inventory.v1.AlertAdded
 */
export type AlertAdded = Message<"inventory.v1.AlertAdded"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: inventory.v1.RiskLevel risk_level = 2;
   */
  riskLevel: RiskLevel;

  /**
   * @generated from field: string id = 3;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.AlertAdded.
 * Use `create(AlertAddedSchema)` to create a new message.
 */
export const AlertAddedSchema: GenMessage<AlertAdded> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 120);

/**
 * @generated from message inventory.v1.AlertStatusChange
 */
export type AlertStatusChange = Message<"inventory.v1.AlertStatusChange"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: inventory.v1.AlertStatus prev_status = 2;
   */
  prevStatus: AlertStatus;

  /**
   * @generated from field: inventory.v1.AlertStatus new_status = 3;
   */
  newStatus: AlertStatus;

  /**
   * @generated from field: string alert_id = 4;
   */
  alertId: string;
};

/**
 * Describes the message inventory.v1.AlertStatusChange.
 * Use `create(AlertStatusChangeSchema)` to create a new message.
 */
export const AlertStatusChangeSchema: GenMessage<AlertStatusChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 121);

/**
 * @generated from message inventory.v1.AlertSeverityChange
 */
export type AlertSeverityChange = Message<"inventory.v1.AlertSeverityChange"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: inventory.v1.RiskLevel prev_severity = 2;
   */
  prevSeverity: RiskLevel;

  /**
   * @generated from field: inventory.v1.RiskLevel new_severity = 3;
   */
  newSeverity: RiskLevel;

  /**
   * @generated from field: string id = 4;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.AlertSeverityChange.
 * Use `create(AlertSeverityChangeSchema)` to create a new message.
 */
export const AlertSeverityChangeSchema: GenMessage<AlertSeverityChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 122);

/**
 * @generated from message inventory.v1.CompanyCreated
 */
export type CompanyCreated = Message<"inventory.v1.CompanyCreated"> & {
};

/**
 * Describes the message inventory.v1.CompanyCreated.
 * Use `create(CompanyCreatedSchema)` to create a new message.
 */
export const CompanyCreatedSchema: GenMessage<CompanyCreated> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 123);

/**
 * @generated from message inventory.v1.Source
 */
export type Source = Message<"inventory.v1.Source"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string img_url = 2;
   */
  imgUrl: string;
};

/**
 * Describes the message inventory.v1.Source.
 * Use `create(SourceSchema)` to create a new message.
 */
export const SourceSchema: GenMessage<Source> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 124);

/**
 * @generated from message inventory.v1.Bookmark
 */
export type Bookmark = Message<"inventory.v1.Bookmark"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string company_id = 2;
   */
  companyId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: string favicon_url = 5;
   */
  faviconUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.Bookmark.
 * Use `create(BookmarkSchema)` to create a new message.
 */
export const BookmarkSchema: GenMessage<Bookmark> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 125);

/**
 * @generated from message inventory.v1.GetBookmarksRequest
 */
export type GetBookmarksRequest = Message<"inventory.v1.GetBookmarksRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;
};

/**
 * Describes the message inventory.v1.GetBookmarksRequest.
 * Use `create(GetBookmarksRequestSchema)` to create a new message.
 */
export const GetBookmarksRequestSchema: GenMessage<GetBookmarksRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 126);

/**
 * @generated from message inventory.v1.GetBookmarksResponse
 */
export type GetBookmarksResponse = Message<"inventory.v1.GetBookmarksResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Bookmark bookmarks = 1;
   */
  bookmarks: Bookmark[];
};

/**
 * Describes the message inventory.v1.GetBookmarksResponse.
 * Use `create(GetBookmarksResponseSchema)` to create a new message.
 */
export const GetBookmarksResponseSchema: GenMessage<GetBookmarksResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 127);

/**
 * @generated from message inventory.v1.AddBookmarkRequest
 */
export type AddBookmarkRequest = Message<"inventory.v1.AddBookmarkRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;
};

/**
 * Describes the message inventory.v1.AddBookmarkRequest.
 * Use `create(AddBookmarkRequestSchema)` to create a new message.
 */
export const AddBookmarkRequestSchema: GenMessage<AddBookmarkRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 128);

/**
 * @generated from message inventory.v1.AddBookmarkResponse
 */
export type AddBookmarkResponse = Message<"inventory.v1.AddBookmarkResponse"> & {
};

/**
 * Describes the message inventory.v1.AddBookmarkResponse.
 * Use `create(AddBookmarkResponseSchema)` to create a new message.
 */
export const AddBookmarkResponseSchema: GenMessage<AddBookmarkResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 129);

/**
 * @generated from message inventory.v1.UpdateBookmarkRequest
 */
export type UpdateBookmarkRequest = Message<"inventory.v1.UpdateBookmarkRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;
};

/**
 * Describes the message inventory.v1.UpdateBookmarkRequest.
 * Use `create(UpdateBookmarkRequestSchema)` to create a new message.
 */
export const UpdateBookmarkRequestSchema: GenMessage<UpdateBookmarkRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 130);

/**
 * @generated from message inventory.v1.UpdateBookmarkResponse
 */
export type UpdateBookmarkResponse = Message<"inventory.v1.UpdateBookmarkResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateBookmarkResponse.
 * Use `create(UpdateBookmarkResponseSchema)` to create a new message.
 */
export const UpdateBookmarkResponseSchema: GenMessage<UpdateBookmarkResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 131);

/**
 * @generated from message inventory.v1.DeleteBookmarkRequest
 */
export type DeleteBookmarkRequest = Message<"inventory.v1.DeleteBookmarkRequest"> & {
  /**
   * @generated from field: string bookmark_id = 1;
   */
  bookmarkId: string;
};

/**
 * Describes the message inventory.v1.DeleteBookmarkRequest.
 * Use `create(DeleteBookmarkRequestSchema)` to create a new message.
 */
export const DeleteBookmarkRequestSchema: GenMessage<DeleteBookmarkRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 132);

/**
 * @generated from message inventory.v1.DeleteBookmarkResponse
 */
export type DeleteBookmarkResponse = Message<"inventory.v1.DeleteBookmarkResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteBookmarkResponse.
 * Use `create(DeleteBookmarkResponseSchema)` to create a new message.
 */
export const DeleteBookmarkResponseSchema: GenMessage<DeleteBookmarkResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 133);

/**
 * @generated from message inventory.v1.ReprojectOrgCompanyRequest
 */
export type ReprojectOrgCompanyRequest = Message<"inventory.v1.ReprojectOrgCompanyRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message inventory.v1.ReprojectOrgCompanyRequest.
 * Use `create(ReprojectOrgCompanyRequestSchema)` to create a new message.
 */
export const ReprojectOrgCompanyRequestSchema: GenMessage<ReprojectOrgCompanyRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 134);

/**
 * @generated from message inventory.v1.ReprojectOrgCompanyResponse
 */
export type ReprojectOrgCompanyResponse = Message<"inventory.v1.ReprojectOrgCompanyResponse"> & {
};

/**
 * Describes the message inventory.v1.ReprojectOrgCompanyResponse.
 * Use `create(ReprojectOrgCompanyResponseSchema)` to create a new message.
 */
export const ReprojectOrgCompanyResponseSchema: GenMessage<ReprojectOrgCompanyResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 135);

/**
 * @generated from message inventory.v1.ReprojectOrgCompanyEngagementRequest
 */
export type ReprojectOrgCompanyEngagementRequest = Message<"inventory.v1.ReprojectOrgCompanyEngagementRequest"> & {
  /**
   * @generated from field: string org_company_engagement_id = 1;
   */
  orgCompanyEngagementId: string;
};

/**
 * Describes the message inventory.v1.ReprojectOrgCompanyEngagementRequest.
 * Use `create(ReprojectOrgCompanyEngagementRequestSchema)` to create a new message.
 */
export const ReprojectOrgCompanyEngagementRequestSchema: GenMessage<ReprojectOrgCompanyEngagementRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 136);

/**
 * @generated from message inventory.v1.ReprojectOrgCompanyEngagementResponse
 */
export type ReprojectOrgCompanyEngagementResponse = Message<"inventory.v1.ReprojectOrgCompanyEngagementResponse"> & {
};

/**
 * Describes the message inventory.v1.ReprojectOrgCompanyEngagementResponse.
 * Use `create(ReprojectOrgCompanyEngagementResponseSchema)` to create a new message.
 */
export const ReprojectOrgCompanyEngagementResponseSchema: GenMessage<ReprojectOrgCompanyEngagementResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 137);

/**
 * @generated from message inventory.v1.ListEngagementsRequest
 */
export type ListEngagementsRequest = Message<"inventory.v1.ListEngagementsRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message inventory.v1.ListEngagementsRequest.
 * Use `create(ListEngagementsRequestSchema)` to create a new message.
 */
export const ListEngagementsRequestSchema: GenMessage<ListEngagementsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 138);

/**
 * @generated from message inventory.v1.ListEngagementsResponse
 */
export type ListEngagementsResponse = Message<"inventory.v1.ListEngagementsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.OrgCompanyEngagement engagements = 1;
   */
  engagements: OrgCompanyEngagement[];
};

/**
 * Describes the message inventory.v1.ListEngagementsResponse.
 * Use `create(ListEngagementsResponseSchema)` to create a new message.
 */
export const ListEngagementsResponseSchema: GenMessage<ListEngagementsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 139);

/**
 * @generated from message inventory.v1.GetEngagementRequest
 */
export type GetEngagementRequest = Message<"inventory.v1.GetEngagementRequest"> & {
  /**
   * @generated from field: string engagement_id = 1;
   */
  engagementId: string;
};

/**
 * Describes the message inventory.v1.GetEngagementRequest.
 * Use `create(GetEngagementRequestSchema)` to create a new message.
 */
export const GetEngagementRequestSchema: GenMessage<GetEngagementRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 140);

/**
 * @generated from message inventory.v1.GetEngagementResponse
 */
export type GetEngagementResponse = Message<"inventory.v1.GetEngagementResponse"> & {
  /**
   * @generated from field: inventory.v1.OrgCompanyEngagement engagement = 1;
   */
  engagement?: OrgCompanyEngagement;
};

/**
 * Describes the message inventory.v1.GetEngagementResponse.
 * Use `create(GetEngagementResponseSchema)` to create a new message.
 */
export const GetEngagementResponseSchema: GenMessage<GetEngagementResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 141);

/**
 * @generated from message inventory.v1.GetCompanySubprocessorsRequest
 */
export type GetCompanySubprocessorsRequest = Message<"inventory.v1.GetCompanySubprocessorsRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;
};

/**
 * Describes the message inventory.v1.GetCompanySubprocessorsRequest.
 * Use `create(GetCompanySubprocessorsRequestSchema)` to create a new message.
 */
export const GetCompanySubprocessorsRequestSchema: GenMessage<GetCompanySubprocessorsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 142);

/**
 * @generated from message inventory.v1.GetCompanySubprocessorsResponse
 */
export type GetCompanySubprocessorsResponse = Message<"inventory.v1.GetCompanySubprocessorsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.CompanySubprocessor subprocessors = 1;
   */
  subprocessors: CompanySubprocessor[];
};

/**
 * Describes the message inventory.v1.GetCompanySubprocessorsResponse.
 * Use `create(GetCompanySubprocessorsResponseSchema)` to create a new message.
 */
export const GetCompanySubprocessorsResponseSchema: GenMessage<GetCompanySubprocessorsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 143);

/**
 * @generated from message inventory.v1.ReanalyzeCompanySubprocessorsRequest
 */
export type ReanalyzeCompanySubprocessorsRequest = Message<"inventory.v1.ReanalyzeCompanySubprocessorsRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message inventory.v1.ReanalyzeCompanySubprocessorsRequest.
 * Use `create(ReanalyzeCompanySubprocessorsRequestSchema)` to create a new message.
 */
export const ReanalyzeCompanySubprocessorsRequestSchema: GenMessage<ReanalyzeCompanySubprocessorsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 144);

/**
 * @generated from message inventory.v1.ReanalyzeCompanySubprocessorsResponse
 */
export type ReanalyzeCompanySubprocessorsResponse = Message<"inventory.v1.ReanalyzeCompanySubprocessorsResponse"> & {
};

/**
 * Describes the message inventory.v1.ReanalyzeCompanySubprocessorsResponse.
 * Use `create(ReanalyzeCompanySubprocessorsResponseSchema)` to create a new message.
 */
export const ReanalyzeCompanySubprocessorsResponseSchema: GenMessage<ReanalyzeCompanySubprocessorsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 145);

/**
 * @generated from message inventory.v1.ListAggregatedSubprocessorsRequest
 */
export type ListAggregatedSubprocessorsRequest = Message<"inventory.v1.ListAggregatedSubprocessorsRequest"> & {
};

/**
 * Describes the message inventory.v1.ListAggregatedSubprocessorsRequest.
 * Use `create(ListAggregatedSubprocessorsRequestSchema)` to create a new message.
 */
export const ListAggregatedSubprocessorsRequestSchema: GenMessage<ListAggregatedSubprocessorsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 146);

/**
 * @generated from message inventory.v1.ListAggregatedSubprocessorsResponse
 */
export type ListAggregatedSubprocessorsResponse = Message<"inventory.v1.ListAggregatedSubprocessorsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AggregatedSubprocessor aggregated_subprocessors = 1;
   */
  aggregatedSubprocessors: AggregatedSubprocessor[];
};

/**
 * Describes the message inventory.v1.ListAggregatedSubprocessorsResponse.
 * Use `create(ListAggregatedSubprocessorsResponseSchema)` to create a new message.
 */
export const ListAggregatedSubprocessorsResponseSchema: GenMessage<ListAggregatedSubprocessorsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 147);

/**
 * @generated from message inventory.v1.AggregatedSubprocessor
 */
export type AggregatedSubprocessor = Message<"inventory.v1.AggregatedSubprocessor"> & {
  /**
   * @generated from field: string subprocessor_company_id = 1;
   */
  subprocessorCompanyId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string domain = 3;
   */
  domain: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: optional string company_location = 5;
   */
  companyLocation?: string;

  /**
   * @generated from field: optional string industry_sector = 6;
   */
  industrySector?: string;

  /**
   * @generated from field: int32 third_party_count = 7;
   */
  thirdPartyCount: number;

  /**
   * @generated from field: repeated inventory.v1.ThirdPartySubprocessorInfo third_parties = 8;
   */
  thirdParties: ThirdPartySubprocessorInfo[];

  /**
   * @generated from field: optional string long_description = 9;
   */
  longDescription?: string;

  /**
   * Company-scoped, mirroring companies.ai_posture for the subprocessor company.
   * A row here IS a company, collapsed across every relationship, so the
   * relationship-scoped is_model_provider has no single value at this grain and is
   * deliberately not surfaced; see CompanySubprocessor.is_model_provider for that.
   * "Model provider" on the fourth-party page means
   * ai_posture == AI_POSTURE_MODEL_PROVIDER.
   * UNSPECIFIED => not classified; the FE folds this with NON_AI into "AI not detected".
   *
   * @generated from field: inventory.v1.AIPosture ai_posture = 10;
   */
  aiPosture: AIPosture;
};

/**
 * Describes the message inventory.v1.AggregatedSubprocessor.
 * Use `create(AggregatedSubprocessorSchema)` to create a new message.
 */
export const AggregatedSubprocessorSchema: GenMessage<AggregatedSubprocessor> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 148);

/**
 * @generated from message inventory.v1.ThirdPartySubprocessorInfo
 */
export type ThirdPartySubprocessorInfo = Message<"inventory.v1.ThirdPartySubprocessorInfo"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * @generated from field: repeated string processing_locations = 2;
   */
  processingLocations: string[];

  /**
   * @generated from field: optional string purpose = 3;
   */
  purpose?: string;

  /**
   * @generated from field: optional string extra_info = 4;
   */
  extraInfo?: string;
};

/**
 * Describes the message inventory.v1.ThirdPartySubprocessorInfo.
 * Use `create(ThirdPartySubprocessorInfoSchema)` to create a new message.
 */
export const ThirdPartySubprocessorInfoSchema: GenMessage<ThirdPartySubprocessorInfo> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 149);

/**
 * @generated from message inventory.v1.CompanySubprocessor
 */
export type CompanySubprocessor = Message<"inventory.v1.CompanySubprocessor"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string subprocessor_company_id = 2;
   */
  subprocessorCompanyId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string domain = 4;
   */
  domain: string;

  /**
   * @generated from field: optional string purpose = 5;
   */
  purpose?: string;

  /**
   * @generated from field: repeated string processing_locations = 6;
   */
  processingLocations: string[];

  /**
   * @generated from field: optional string extra_info = 7;
   */
  extraInfo?: string;

  /**
   * @generated from field: optional string description = 8;
   */
  description?: string;

  /**
   * @generated from field: optional string company_location = 9;
   */
  companyLocation?: string;

  /**
   * @generated from field: optional string industry_sector = 10;
   */
  industrySector?: string;

  /**
   * Company-scoped, like AggregatedSubprocessor.ai_posture: mirrors
   * companies.ai_posture for the subprocessor company — what this fourth party
   * is in general. UNSPECIFIED => not classified; the FE folds this with NON_AI
   * into "AI not detected".
   *
   * @generated from field: inventory.v1.AIPosture ai_posture = 11;
   */
  aiPosture: AIPosture;

  /**
   * Relationship-scoped, straight from the company_subprocessors.is_model_provider
   * column: does this subprocessor power *this* vendor's AI? Well-defined here
   * because the message is one row per (company, subprocessor); the aggregated
   * fourth-party view has no single value for it and so omits it.
   * A fourth party can have ai_posture == MODEL_PROVIDER and this false —
   * AWS under GitHub is exactly that.
   *
   * @generated from field: bool is_model_provider = 12;
   */
  isModelProvider: boolean;
};

/**
 * Describes the message inventory.v1.CompanySubprocessor.
 * Use `create(CompanySubprocessorSchema)` to create a new message.
 */
export const CompanySubprocessorSchema: GenMessage<CompanySubprocessor> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 150);

/**
 * @generated from message inventory.v1.DataTypeInfo
 */
export type DataTypeInfo = Message<"inventory.v1.DataTypeInfo"> & {
  /**
   * @generated from field: string data_type = 1;
   */
  dataType: string;

  /**
   * @generated from field: inventory.v1.DataTypeSource source = 2;
   */
  source: DataTypeSource;

  /**
   * used to link to a given signal that was created as a result of this problematic data access,
   * applicable only if source is UNDOCUMENTED_ACCESS (otherwise there would be no signal to link to)
   *
   * @generated from field: optional string signal_id = 3;
   */
  signalId?: string;
};

/**
 * Describes the message inventory.v1.DataTypeInfo.
 * Use `create(DataTypeInfoSchema)` to create a new message.
 */
export const DataTypeInfoSchema: GenMessage<DataTypeInfo> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 151);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * An answer option within a template question.
 * When creating a new option, id should be empty.
 *
 * @generated from message inventory.v1.InherentRiskTemplateOption
 */
export type InherentRiskTemplateOption = Message<"inventory.v1.InherentRiskTemplateOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: inventory.v1.RiskLevel severity = 3;
   */
  severity: RiskLevel;

  /**
   * Identifier an inbound integration uses to refer to this option in an irq[]
   * webhook payload. Empty string means unset. Unique per question.
   *
   * @generated from field: string external_key = 4;
   */
  externalKey: string;
};

/**
 * Describes the message inventory.v1.InherentRiskTemplateOption.
 * Use `create(InherentRiskTemplateOptionSchema)` to create a new message.
 */
export const InherentRiskTemplateOptionSchema: GenMessage<InherentRiskTemplateOption> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 152);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * A single question in the IRQ template.
 * When creating a new question, id should be empty.
 *
 * @generated from message inventory.v1.InherentRiskTemplateQuestion
 */
export type InherentRiskTemplateQuestion = Message<"inventory.v1.InherentRiskTemplateQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: inventory.v1.InherentRiskQuestionType type = 2;
   */
  type: InherentRiskQuestionType;

  /**
   * @generated from field: string question = 3;
   */
  question: string;

  /**
   * @generated from field: repeated inventory.v1.InherentRiskTemplateOption options = 4;
   */
  options: InherentRiskTemplateOption[];

  /**
   * @generated from field: optional inventory.v1.TemplateBuilderCondition condition = 5;
   */
  condition?: TemplateBuilderCondition;

  /**
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * Identifier an inbound integration uses to refer to this question in an
   * irq[] webhook payload. Empty string means unset. Unique per org.
   *
   * @generated from field: string external_key = 7;
   */
  externalKey: string;

  /**
   * @generated from field: string sub_category = 8;
   */
  subCategory: string;

  /**
   * @generated from field: int32 display_order = 9;
   */
  displayOrder: number;
};

/**
 * Describes the message inventory.v1.InherentRiskTemplateQuestion.
 * Use `create(InherentRiskTemplateQuestionSchema)` to create a new message.
 */
export const InherentRiskTemplateQuestionSchema: GenMessage<InherentRiskTemplateQuestion> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 153);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * A category (section) grouping questions in the IRQ template.
 * When creating a new category, id should be empty.
 *
 * @generated from message inventory.v1.InherentRiskTemplateCategory
 */
export type InherentRiskTemplateCategory = Message<"inventory.v1.InherentRiskTemplateCategory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: repeated inventory.v1.InherentRiskTemplateQuestion questions = 3;
   */
  questions: InherentRiskTemplateQuestion[];
};

/**
 * Describes the message inventory.v1.InherentRiskTemplateCategory.
 * Use `create(InherentRiskTemplateCategorySchema)` to create a new message.
 */
export const InherentRiskTemplateCategorySchema: GenMessage<InherentRiskTemplateCategory> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 154);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * One inherent risk level paired with the literal value an inbound integration
 * sends for it.
 *
 * @generated from message inventory.v1.InherentRiskLevelValueMapping
 */
export type InherentRiskLevelValueMapping = Message<"inventory.v1.InherentRiskLevelValueMapping"> & {
  /**
   * Must be a specified level (LOW / MEDIUM / HIGH / CRITICAL).
   *
   * @generated from field: inventory.v1.RiskLevel level = 1;
   */
  level: RiskLevel;

  /**
   * Exact value as it appears in the integration payload, compared verbatim —
   * the level-side counterpart of an answer option's external_key. Empty string
   * means the level is unmapped and the entry is dropped on save.
   *
   * @generated from field: string external_value = 2;
   */
  externalValue: string;
};

/**
 * Describes the message inventory.v1.InherentRiskLevelValueMapping.
 * Use `create(InherentRiskLevelValueMappingSchema)` to create a new message.
 */
export const InherentRiskLevelValueMappingSchema: GenMessage<InherentRiskLevelValueMapping> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 155);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 * Locates and decodes the inherent risk level inside an inbound integration
 * payload. Needed for pull integrations (ZipHQ), whose customers cannot shape
 * the outbound body; push integrations send inherent_risk_level directly and
 * ignore this.
 *
 * @generated from message inventory.v1.InherentRiskLevelMapping
 */
export type InherentRiskLevelMapping = Message<"inventory.v1.InherentRiskLevelMapping"> & {
  /**
   * Exact name of the payload field holding the level. For ZipHQ this is the
   * request attribute's "name" (e.g. "Inherent Risk Rating"), so it is matched
   * against the same payload field names as question external_keys.
   *
   * It is NOT itself a question external_key: it is never resolved against the
   * IRQ template, it points at the level rather than at a question, and the
   * same payload field may legitimately serve as both (its value can answer a
   * question and decode the level).
   *
   * @generated from field: string external_key = 1;
   */
  externalKey: string;

  /**
   * At most one entry per level; external_values must be unique.
   *
   * @generated from field: repeated inventory.v1.InherentRiskLevelValueMapping values = 2;
   */
  values: InherentRiskLevelValueMapping[];
};

/**
 * Describes the message inventory.v1.InherentRiskLevelMapping.
 * Use `create(InherentRiskLevelMappingSchema)` to create a new message.
 */
export const InherentRiskLevelMappingSchema: GenMessage<InherentRiskLevelMapping> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 156);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from message inventory.v1.InherentRiskTemplate
 */
export type InherentRiskTemplate = Message<"inventory.v1.InherentRiskTemplate"> & {
  /**
   * @generated from field: repeated inventory.v1.InherentRiskTemplateCategory categories = 1;
   */
  categories: InherentRiskTemplateCategory[];

  /**
   * Absent on read when the org has no mapping. Absent on update clears it,
   * matching the full-state-replacement semantics of categories.
   *
   * @generated from field: optional inventory.v1.InherentRiskLevelMapping level_mapping = 2;
   */
  levelMapping?: InherentRiskLevelMapping;
};

/**
 * Describes the message inventory.v1.InherentRiskTemplate.
 * Use `create(InherentRiskTemplateSchema)` to create a new message.
 */
export const InherentRiskTemplateSchema: GenMessage<InherentRiskTemplate> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 157);

/**
 * @generated from message inventory.v1.GetInherentRiskTemplateRequest
 */
export type GetInherentRiskTemplateRequest = Message<"inventory.v1.GetInherentRiskTemplateRequest"> & {
};

/**
 * Describes the message inventory.v1.GetInherentRiskTemplateRequest.
 * Use `create(GetInherentRiskTemplateRequestSchema)` to create a new message.
 */
export const GetInherentRiskTemplateRequestSchema: GenMessage<GetInherentRiskTemplateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 158);

/**
 * @generated from message inventory.v1.GetInherentRiskTemplateResponse
 */
export type GetInherentRiskTemplateResponse = Message<"inventory.v1.GetInherentRiskTemplateResponse"> & {
  /**
   * @generated from field: inventory.v1.InherentRiskTemplate template = 1;
   */
  template?: InherentRiskTemplate;
};

/**
 * Describes the message inventory.v1.GetInherentRiskTemplateResponse.
 * Use `create(GetInherentRiskTemplateResponseSchema)` to create a new message.
 */
export const GetInherentRiskTemplateResponseSchema: GenMessage<GetInherentRiskTemplateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 159);

/**
 * Full state replacement: the request contains the complete desired template state.
 * - Objects present in the request but missing from the current template are created (id should be given).
 * - Objects present in the current template but missing from this request are deleted.
 * - Objects with a matching id but different fields are updated.
 *
 * @generated from message inventory.v1.UpdateInherentRiskTemplateRequest
 */
export type UpdateInherentRiskTemplateRequest = Message<"inventory.v1.UpdateInherentRiskTemplateRequest"> & {
  /**
   * @generated from field: inventory.v1.InherentRiskTemplate template = 1;
   */
  template?: InherentRiskTemplate;
};

/**
 * Describes the message inventory.v1.UpdateInherentRiskTemplateRequest.
 * Use `create(UpdateInherentRiskTemplateRequestSchema)` to create a new message.
 */
export const UpdateInherentRiskTemplateRequestSchema: GenMessage<UpdateInherentRiskTemplateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 160);

/**
 * @generated from message inventory.v1.UpdateInherentRiskTemplateResponse
 */
export type UpdateInherentRiskTemplateResponse = Message<"inventory.v1.UpdateInherentRiskTemplateResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateInherentRiskTemplateResponse.
 * Use `create(UpdateInherentRiskTemplateResponseSchema)` to create a new message.
 */
export const UpdateInherentRiskTemplateResponseSchema: GenMessage<UpdateInherentRiskTemplateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 161);

/**
 * @generated from message inventory.v1.ResetInherentRiskTemplateRequest
 */
export type ResetInherentRiskTemplateRequest = Message<"inventory.v1.ResetInherentRiskTemplateRequest"> & {
};

/**
 * Describes the message inventory.v1.ResetInherentRiskTemplateRequest.
 * Use `create(ResetInherentRiskTemplateRequestSchema)` to create a new message.
 */
export const ResetInherentRiskTemplateRequestSchema: GenMessage<ResetInherentRiskTemplateRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 162);

/**
 * @generated from message inventory.v1.ResetInherentRiskTemplateResponse
 */
export type ResetInherentRiskTemplateResponse = Message<"inventory.v1.ResetInherentRiskTemplateResponse"> & {
};

/**
 * Describes the message inventory.v1.ResetInherentRiskTemplateResponse.
 * Use `create(ResetInherentRiskTemplateResponseSchema)` to create a new message.
 */
export const ResetInherentRiskTemplateResponseSchema: GenMessage<ResetInherentRiskTemplateResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 163);

/**
 * @generated from message inventory.v1.SearchEngagementCandidatesRequest
 */
export type SearchEngagementCandidatesRequest = Message<"inventory.v1.SearchEngagementCandidatesRequest"> & {
  /**
   * @generated from field: string vendor_name = 1;
   */
  vendorName: string;
};

/**
 * Describes the message inventory.v1.SearchEngagementCandidatesRequest.
 * Use `create(SearchEngagementCandidatesRequestSchema)` to create a new message.
 */
export const SearchEngagementCandidatesRequestSchema: GenMessage<SearchEngagementCandidatesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 164);

/**
 * @generated from message inventory.v1.SearchEngagementCandidatesResponse
 */
export type SearchEngagementCandidatesResponse = Message<"inventory.v1.SearchEngagementCandidatesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.EngagementAutocompleteItem engagements = 1;
   */
  engagements: EngagementAutocompleteItem[];
};

/**
 * Describes the message inventory.v1.SearchEngagementCandidatesResponse.
 * Use `create(SearchEngagementCandidatesResponseSchema)` to create a new message.
 */
export const SearchEngagementCandidatesResponseSchema: GenMessage<SearchEngagementCandidatesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 165);

/**
 * @generated from message inventory.v1.GetCompanyAIPostureRequest
 */
export type GetCompanyAIPostureRequest = Message<"inventory.v1.GetCompanyAIPostureRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message inventory.v1.GetCompanyAIPostureRequest.
 * Use `create(GetCompanyAIPostureRequestSchema)` to create a new message.
 */
export const GetCompanyAIPostureRequestSchema: GenMessage<GetCompanyAIPostureRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 166);

/**
 * @generated from message inventory.v1.GetCompanyAIPostureResponse
 */
export type GetCompanyAIPostureResponse = Message<"inventory.v1.GetCompanyAIPostureResponse"> & {
  /**
   * Unset => the vendor has no AI classification; the FE hides the widget
   * entirely (PRD 4.4 — no empty state).
   *
   * @generated from field: optional inventory.v1.CompanyAIProfile ai_profile = 1;
   */
  aiProfile?: CompanyAIProfile;

  /**
   * @generated from field: optional inventory.v1.AISecurityPosture security_posture = 2;
   */
  securityPosture?: AISecurityPosture;

  /**
   * Open alerts on this vendor, per PRD 7.5.
   *
   * @generated from field: repeated inventory.v1.AlertCountStat open_alerts_by_level = 3;
   */
  openAlertsByLevel: AlertCountStat[];
};

/**
 * Describes the message inventory.v1.GetCompanyAIPostureResponse.
 * Use `create(GetCompanyAIPostureResponseSchema)` to create a new message.
 */
export const GetCompanyAIPostureResponseSchema: GenMessage<GetCompanyAIPostureResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 167);

/**
 * @generated from message inventory.v1.AISecurityPosture
 */
export type AISecurityPosture = Message<"inventory.v1.AISecurityPosture"> & {
  /**
   * numerator of the posture score
   *
   * @generated from field: int32 validated_controls = 1;
   */
  validatedControls: number;

  /**
   * denominator: enabled + applicable only
   *
   * @generated from field: int32 total_controls = 2;
   */
  totalControls: number;

  /**
   * @generated from field: repeated inventory.v1.ControlCountStat controls_by_status = 3;
   */
  controlsByStatus: ControlCountStat[];

  /**
   * @generated from field: optional string last_assessment_id = 4;
   */
  lastAssessmentId?: string;

  /**
   * @generated from field: optional string last_assessment_name = 5;
   */
  lastAssessmentName?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_assessment_at = 6;
   */
  lastAssessmentAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.AISecurityPosture.
 * Use `create(AISecurityPostureSchema)` to create a new message.
 */
export const AISecurityPostureSchema: GenMessage<AISecurityPosture> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 168);

/**
 * @generated from message inventory.v1.OverrideCompanyAIProfileRequest
 */
export type OverrideCompanyAIProfileRequest = Message<"inventory.v1.OverrideCompanyAIProfileRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;

  /**
   * Each field left unset is kept as is. AI_POSTURE_UNSPECIFIED is rejected: a NULL posture is the
   * "never classified" signal, not a tier an override may set.
   *
   * @generated from field: optional inventory.v1.AIPosture posture = 2;
   */
  posture?: AIPosture;

  /**
   * The full replacement set, not a delta; an empty list clears every capability.
   *
   * @generated from field: optional inventory.v1.AICapabilityList capabilities = 3;
   */
  capabilities?: AICapabilityList;
};

/**
 * Describes the message inventory.v1.OverrideCompanyAIProfileRequest.
 * Use `create(OverrideCompanyAIProfileRequestSchema)` to create a new message.
 */
export const OverrideCompanyAIProfileRequestSchema: GenMessage<OverrideCompanyAIProfileRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 169);

/**
 * Wraps the repeated field so "leave untouched" (unset) and "clear" (empty) are distinguishable.
 *
 * @generated from message inventory.v1.AICapabilityList
 */
export type AICapabilityList = Message<"inventory.v1.AICapabilityList"> & {
  /**
   * @generated from field: repeated inventory.v1.AICapability values = 1;
   */
  values: AICapability[];
};

/**
 * Describes the message inventory.v1.AICapabilityList.
 * Use `create(AICapabilityListSchema)` to create a new message.
 */
export const AICapabilityListSchema: GenMessage<AICapabilityList> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 170);

/**
 * @generated from message inventory.v1.OverrideCompanyAIProfileResponse
 */
export type OverrideCompanyAIProfileResponse = Message<"inventory.v1.OverrideCompanyAIProfileResponse"> & {
  /**
   * The stored profile after the write, read back through the same path the inventory uses.
   *
   * @generated from field: inventory.v1.CompanyAIProfile ai_profile = 1;
   */
  aiProfile?: CompanyAIProfile;
};

/**
 * Describes the message inventory.v1.OverrideCompanyAIProfileResponse.
 * Use `create(OverrideCompanyAIProfileResponseSchema)` to create a new message.
 */
export const OverrideCompanyAIProfileResponseSchema: GenMessage<OverrideCompanyAIProfileResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 171);

/**
 * @generated from message inventory.v1.ReclassifyCompanyAIProfileRequest
 */
export type ReclassifyCompanyAIProfileRequest = Message<"inventory.v1.ReclassifyCompanyAIProfileRequest"> & {
  /**
   * @generated from field: string org_company_id = 1;
   */
  orgCompanyId: string;
};

/**
 * Describes the message inventory.v1.ReclassifyCompanyAIProfileRequest.
 * Use `create(ReclassifyCompanyAIProfileRequestSchema)` to create a new message.
 */
export const ReclassifyCompanyAIProfileRequestSchema: GenMessage<ReclassifyCompanyAIProfileRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 172);

/**
 * @generated from message inventory.v1.ReclassifyCompanyAIProfileResponse
 */
export type ReclassifyCompanyAIProfileResponse = Message<"inventory.v1.ReclassifyCompanyAIProfileResponse"> & {
};

/**
 * Describes the message inventory.v1.ReclassifyCompanyAIProfileResponse.
 * Use `create(ReclassifyCompanyAIProfileResponseSchema)` to create a new message.
 */
export const ReclassifyCompanyAIProfileResponseSchema: GenMessage<ReclassifyCompanyAIProfileResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_company_service, 173);

/**
 * @generated from enum inventory.v1.ReAssessmentDueDateUpdateType
 */
export enum ReAssessmentDueDateUpdateType {
  /**
   * @generated from enum value: RE_ASSESSMENT_DUE_DATE_UPDATE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RE_ASSESSMENT_DUE_DATE_UPDATE_TYPE_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * @generated from enum value: RE_ASSESSMENT_DUE_DATE_UPDATE_TYPE_CADENCE = 2;
   */
  CADENCE = 2,
}

/**
 * Describes the enum inventory.v1.ReAssessmentDueDateUpdateType.
 */
export const ReAssessmentDueDateUpdateTypeSchema: GenEnum<ReAssessmentDueDateUpdateType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 0);

/**
 * CloudAccountClassification is which environment a cloud account holds.
 *
 * @generated from enum inventory.v1.CloudAccountClassification
 */
export enum CloudAccountClassification {
  /**
   * @generated from enum value: CLOUD_ACCOUNT_CLASSIFICATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLOUD_ACCOUNT_CLASSIFICATION_PRODUCTION = 1;
   */
  PRODUCTION = 1,

  /**
   * @generated from enum value: CLOUD_ACCOUNT_CLASSIFICATION_STAGING = 2;
   */
  STAGING = 2,

  /**
   * @generated from enum value: CLOUD_ACCOUNT_CLASSIFICATION_DEVELOPMENT = 3;
   */
  DEVELOPMENT = 3,

  /**
   * @generated from enum value: CLOUD_ACCOUNT_CLASSIFICATION_UNCLASSIFIED = 4;
   */
  UNCLASSIFIED = 4,
}

/**
 * Describes the enum inventory.v1.CloudAccountClassification.
 */
export const CloudAccountClassificationSchema: GenEnum<CloudAccountClassification> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 1);

/**
 * @generated from enum inventory.v1.PointOfContactChangeType
 */
export enum PointOfContactChangeType {
  /**
   * @generated from enum value: POINT_OF_CONTACT_CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: POINT_OF_CONTACT_CHANGE_TYPE_CREATE = 1;
   */
  CREATE = 1,

  /**
   * @generated from enum value: POINT_OF_CONTACT_CHANGE_TYPE_ACTIVATE = 2;
   */
  ACTIVATE = 2,

  /**
   * @generated from enum value: POINT_OF_CONTACT_CHANGE_TYPE_DEACTIVATE = 3;
   */
  DEACTIVATE = 3,
}

/**
 * Describes the enum inventory.v1.PointOfContactChangeType.
 */
export const PointOfContactChangeTypeSchema: GenEnum<PointOfContactChangeType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 2);

/**
 * @generated from enum inventory.v1.OrgCompanyEngagementChangeType
 */
export enum OrgCompanyEngagementChangeType {
  /**
   * @generated from enum value: ORG_COMPANY_ENGAGEMENT_CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ORG_COMPANY_ENGAGEMENT_CHANGE_TYPE_CREATE = 1;
   */
  CREATE = 1,

  /**
   * @generated from enum value: ORG_COMPANY_ENGAGEMENT_CHANGE_TYPE_UPDATE = 2;
   */
  UPDATE = 2,

  /**
   * @generated from enum value: ORG_COMPANY_ENGAGEMENT_CHANGE_TYPE_DELETE = 3;
   */
  DELETE = 3,

  /**
   * @generated from enum value: ORG_COMPANY_ENGAGEMENT_CHANGE_TYPE_IRQ_UPDATE = 4;
   */
  IRQ_UPDATE = 4,
}

/**
 * Describes the enum inventory.v1.OrgCompanyEngagementChangeType.
 */
export const OrgCompanyEngagementChangeTypeSchema: GenEnum<OrgCompanyEngagementChangeType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 3);

/**
 * @generated from enum inventory.v1.PermissionCategory
 */
export enum PermissionCategory {
  /**
   * @generated from enum value: PERMISSION_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_DATA_ACCESS = 1;
   */
  DATA_ACCESS = 1,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_DATA_MODIFICATION = 2;
   */
  DATA_MODIFICATION = 2,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_OPERATIONAL_ENVIRONMENT = 3;
   */
  OPERATIONAL_ENVIRONMENT = 3,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_CONFIGURATION_PERMISSIONS = 4;
   */
  CONFIGURATION_PERMISSIONS = 4,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_IDENTITY_AND_ACCESS_MANAGEMENT = 5;
   */
  IDENTITY_AND_ACCESS_MANAGEMENT = 5,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_EMPLOYEE_DATA_ACCESS = 6;
   */
  EMPLOYEE_DATA_ACCESS = 6,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_EMPLOYEE_DATA_MODIFICATION = 7;
   */
  EMPLOYEE_DATA_MODIFICATION = 7,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_CLOUD_ENVIRONMENT = 8;
   */
  CLOUD_ENVIRONMENT = 8,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_HIGH_PRIVILEGE_APP = 9;
   */
  HIGH_PRIVILEGE_APP = 9,

  /**
   * @generated from enum value: PERMISSION_CATEGORY_NETWORK_ACCESS = 10;
   */
  NETWORK_ACCESS = 10,
}

/**
 * Describes the enum inventory.v1.PermissionCategory.
 */
export const PermissionCategorySchema: GenEnum<PermissionCategory> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 4);

/**
 * @generated from enum inventory.v1.DataTypeSource
 */
export enum DataTypeSource {
  /**
   * @generated from enum value: DATA_TYPE_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATA_TYPE_SOURCE_DOCUMENTED_ONLY = 1;
   */
  DOCUMENTED_ONLY = 1,

  /**
   * @generated from enum value: DATA_TYPE_SOURCE_DOCUMENTED_AND_ACCESSED = 2;
   */
  DOCUMENTED_AND_ACCESSED = 2,

  /**
   * @generated from enum value: DATA_TYPE_SOURCE_UNDOCUMENTED_ACCESS = 3;
   */
  UNDOCUMENTED_ACCESS = 3,
}

/**
 * Describes the enum inventory.v1.DataTypeSource.
 */
export const DataTypeSourceSchema: GenEnum<DataTypeSource> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 5);

/**
 * @generated from enum inventory.v1.InherentRiskCategoryEnum
 */
export enum InherentRiskCategoryEnum {
  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_DATA = 1;
   */
  DATA = 1,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_ATTACK_SURFACE = 2;
   */
  ATTACK_SURFACE = 2,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_SPEND = 3;
   */
  SPEND = 3,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_LOB = 4;
   */
  LOB = 4,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_OUTAGE_OPERATIONAL_IMPACT = 5;
   */
  OUTAGE_OPERATIONAL_IMPACT = 5,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_OUTAGE_BIZ_IMPACT = 6;
   */
  OUTAGE_BIZ_IMPACT = 6,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_INTEG_METHOD = 7;
   */
  INTEG_METHOD = 7,

  /**
   * @generated from enum value: INHERENT_RISK_CATEGORY_ENUM_DATA_SUBPROCESSOR = 8;
   */
  DATA_SUBPROCESSOR = 8,
}

/**
 * Describes the enum inventory.v1.InherentRiskCategoryEnum.
 */
export const InherentRiskCategoryEnumSchema: GenEnum<InherentRiskCategoryEnum> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 6);

/**
 * @generated from enum inventory.v1.InherentRiskSource
 */
export enum InherentRiskSource {
  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_PROJECTED = 1;
   */
  PROJECTED = 1,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_IRQ = 2;
   */
  IRQ = 2,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_INTEGRATION = 3;
   */
  INTEGRATION = 3,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_MICROSOFT_ENTRA_ID = 4;
   */
  MICROSOFT_ENTRA_ID = 4,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_GOOGLE_WORKSPACE = 5;
   */
  GOOGLE_WORKSPACE = 5,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_ZIP = 6;
   */
  ZIP = 6,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_WIZ = 7;
   */
  WIZ = 7,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_NETSKOPE = 8;
   */
  NETSKOPE = 8,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_OKTA = 9;
   */
  OKTA = 9,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_WEBHOOK = 10;
   */
  WEBHOOK = 10,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_INTAKE = 11;
   */
  INTAKE = 11,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_VENDR = 12;
   */
  VENDR = 12,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_ASANA = 13;
   */
  ASANA = 13,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_RAMP = 14;
   */
  RAMP = 14,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_ONETRUST = 15;
   */
  ONETRUST = 15,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_GRAPHITECONNECT = 16;
   */
  GRAPHITECONNECT = 16,

  /**
   * @generated from enum value: INHERENT_RISK_SOURCE_LOGICMANAGER = 17;
   */
  LOGICMANAGER = 17,
}

/**
 * Describes the enum inventory.v1.InherentRiskSource.
 */
export const InherentRiskSourceSchema: GenEnum<InherentRiskSource> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 7);

/**
 * @generated from enum inventory.v1.CustomFieldMultiSelectOptionChangeType
 */
export enum CustomFieldMultiSelectOptionChangeType {
  /**
   * @generated from enum value: CUSTOM_FIELD_MULTI_SELECT_OPTION_CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOM_FIELD_MULTI_SELECT_OPTION_CHANGE_TYPE_ADD = 1;
   */
  ADD = 1,

  /**
   * @generated from enum value: CUSTOM_FIELD_MULTI_SELECT_OPTION_CHANGE_TYPE_REMOVE = 2;
   */
  REMOVE = 2,
}

/**
 * Describes the enum inventory.v1.CustomFieldMultiSelectOptionChangeType.
 */
export const CustomFieldMultiSelectOptionChangeTypeSchema: GenEnum<CustomFieldMultiSelectOptionChangeType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 8);

/**
 * [PERSISTED] stored as protojson JSONB in org_intake_form_submissions.payload — never rename/renumber/remove fields or enum values; adding is safe.
 *
 * @generated from enum inventory.v1.InherentRiskQuestionType
 */
export enum InherentRiskQuestionType {
  /**
   * @generated from enum value: INHERENT_RISK_QUESTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INHERENT_RISK_QUESTION_TYPE_SINGLE_SELECT = 1;
   */
  SINGLE_SELECT = 1,

  /**
   * @generated from enum value: INHERENT_RISK_QUESTION_TYPE_MULTI_SELECT = 2;
   */
  MULTI_SELECT = 2,

  /**
   * @generated from enum value: INHERENT_RISK_QUESTION_TYPE_FREE_TEXT = 3;
   */
  FREE_TEXT = 3,

  /**
   * @generated from enum value: INHERENT_RISK_QUESTION_TYPE_SPEND = 4;
   */
  SPEND = 4,
}

/**
 * Describes the enum inventory.v1.InherentRiskQuestionType.
 */
export const InherentRiskQuestionTypeSchema: GenEnum<InherentRiskQuestionType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_company_service, 9);

/**
 * @generated from service inventory.v1.CompanyInventoryService
 */
export const CompanyInventoryService: GenService<{
  /**
   * AutocompleteCompany is a UI helper function to facilitate the creation of new companies
   * Needs to be in CompanyManagementService because it uses customer specific data to show what companies are already added
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.AutocompleteCompany
   */
  autocompleteCompany: {
    methodKind: "unary";
    input: typeof AutocompleteCompanyRequestSchema;
    output: typeof AutocompleteCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.CreateCompany
   */
  createCompany: {
    methodKind: "unary";
    input: typeof CreateCompanyRequestSchema;
    output: typeof CreateCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ListCompanies
   */
  listCompanies: {
    methodKind: "unary";
    input: typeof ListCompaniesRequestSchema;
    output: typeof ListCompaniesResponseSchema;
  },
  /**
   * ListDiscoverySolutions returns solutions awaiting a connect/dismiss decision
   * (org_company_id is nil). Pending only by default; include_dismissed adds dismissed ones.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.ListDiscoverySolutions
   */
  listDiscoverySolutions: {
    methodKind: "unary";
    input: typeof ListDiscoverySolutionsRequestSchema;
    output: typeof ListDiscoverySolutionsResponseSchema;
  },
  /**
   * GetDiscoverySolution returns drawer detail for a single (unlinked) discovery solution:
   * usage (users, line-of-business, data types), and permissions.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.GetDiscoverySolution
   */
  getDiscoverySolution: {
    methodKind: "unary";
    input: typeof GetDiscoverySolutionRequestSchema;
    output: typeof GetDiscoverySolutionResponseSchema;
  },
  /**
   * SetSolutionDismissed dismisses (dismissed=true) or restores (dismissed=false) a
   * discovery solution. Idempotent; only an unlinked solution can be dismissed.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.SetSolutionDismissed
   */
  setSolutionDismissed: {
    methodKind: "unary";
    input: typeof SetSolutionDismissedRequestSchema;
    output: typeof SetSolutionDismissedResponseSchema;
  },
  /**
   * SetSolutionSuggestedThirdParty overrides the auto-suggested third-party for a discovery
   * solution with a user pick from the inventory (org_company_id set) or clears it (unset).
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.SetSolutionSuggestedThirdParty
   */
  setSolutionSuggestedThirdParty: {
    methodKind: "unary";
    input: typeof SetSolutionSuggestedThirdPartyRequestSchema;
    output: typeof SetSolutionSuggestedThirdPartyResponseSchema;
  },
  /**
   * AddSolutionAssignee assigns a Lema user to a discovery solution.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.AddSolutionAssignee
   */
  addSolutionAssignee: {
    methodKind: "unary";
    input: typeof AddSolutionAssigneeRequestSchema;
    output: typeof AddSolutionAssigneeResponseSchema;
  },
  /**
   * RemoveSolutionAssignee unassigns a Lema user from a discovery solution.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.RemoveSolutionAssignee
   */
  removeSolutionAssignee: {
    methodKind: "unary";
    input: typeof RemoveSolutionAssigneeRequestSchema;
    output: typeof RemoveSolutionAssigneeResponseSchema;
  },
  /**
   * ListSolutionDevices returns the endpoints a discovery solution is installed on, for the drawer's
   * Devices table: the most recently used first, capped at 100. DiscoverySolution.devices_count
   * carries the true total. Empty for solutions with no endpoint source.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.ListSolutionDevices
   */
  listSolutionDevices: {
    methodKind: "unary";
    input: typeof ListSolutionDevicesRequestSchema;
    output: typeof ListSolutionDevicesResponseSchema;
  },
  /**
   * ListSolutionCloudAccounts returns the cloud accounts a discovery solution was found in, for the
   * drawer's Cloud Accounts table: one entry per account, ordered by classification then name, capped
   * at 500. Empty for solutions with no cloud source.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.ListSolutionCloudAccounts
   */
  listSolutionCloudAccounts: {
    methodKind: "unary";
    input: typeof ListSolutionCloudAccountsRequestSchema;
    output: typeof ListSolutionCloudAccountsResponseSchema;
  },
  /**
   * SetCloudAccountClassification overrides the classification derived from the account's
   * organizational placement and name, or clears the override when the classification is unset.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.SetCloudAccountClassification
   */
  setCloudAccountClassification: {
    methodKind: "unary";
    input: typeof SetCloudAccountClassificationRequestSchema;
    output: typeof SetCloudAccountClassificationResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ListEngagements
   */
  listEngagements: {
    methodKind: "unary";
    input: typeof ListEngagementsRequestSchema;
    output: typeof ListEngagementsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ListCompaniesDataTypes
   */
  listCompaniesDataTypes: {
    methodKind: "unary";
    input: typeof ListCompaniesDataTypesRequestSchema;
    output: typeof ListCompaniesDataTypesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetCompany
   */
  getCompany: {
    methodKind: "unary";
    input: typeof GetCompanyRequestSchema;
    output: typeof GetCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetEngagement
   */
  getEngagement: {
    methodKind: "unary";
    input: typeof GetEngagementRequestSchema;
    output: typeof GetEngagementResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanyDrawerMetadata
   */
  getCompanyDrawerMetadata: {
    methodKind: "unary";
    input: typeof GetCompanyDrawerMetadataRequestSchema;
    output: typeof GetCompanyDrawerMetadataResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateCompany
   */
  updateCompany: {
    methodKind: "unary";
    input: typeof UpdateCompanyRequestSchema;
    output: typeof UpdateCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateCompanyInherentRisk
   */
  updateCompanyInherentRisk: {
    methodKind: "unary";
    input: typeof UpdateCompanyInherentRiskRequestSchema;
    output: typeof UpdateCompanyInherentRiskResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetInherentRisk
   */
  getInherentRisk: {
    methodKind: "unary";
    input: typeof GetInherentRiskRequestSchema;
    output: typeof GetInherentRiskResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ListInherentRiskCategories
   */
  listInherentRiskCategories: {
    methodKind: "unary";
    input: typeof ListInherentRiskCategoriesRequestSchema;
    output: typeof ListInherentRiskCategoriesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.SetIRQ
   */
  setIRQ: {
    methodKind: "unary";
    input: typeof SetIRQRequestSchema;
    output: typeof SetIRQResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanyActivityLog
   */
  getCompanyActivityLog: {
    methodKind: "unary";
    input: typeof GetCompanyActivityLogRequestSchema;
    output: typeof GetCompanyActivityLogResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetPointsOfContact
   */
  getPointsOfContact: {
    methodKind: "unary";
    input: typeof GetPointsOfContactRequestSchema;
    output: typeof GetPointsOfContactResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetPointsOfContactsByCompany
   */
  getPointsOfContactsByCompany: {
    methodKind: "unary";
    input: typeof GetPointsOfContactsByCompanyRequestSchema;
    output: typeof GetPointsOfContactsByCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetBookmarks
   */
  getBookmarks: {
    methodKind: "unary";
    input: typeof GetBookmarksRequestSchema;
    output: typeof GetBookmarksResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.AddBookmark
   */
  addBookmark: {
    methodKind: "unary";
    input: typeof AddBookmarkRequestSchema;
    output: typeof AddBookmarkResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateBookmark
   */
  updateBookmark: {
    methodKind: "unary";
    input: typeof UpdateBookmarkRequestSchema;
    output: typeof UpdateBookmarkResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.DeleteBookmark
   */
  deleteBookmark: {
    methodKind: "unary";
    input: typeof DeleteBookmarkRequestSchema;
    output: typeof DeleteBookmarkResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.AutocompleteBusinessOwner
   */
  autocompleteBusinessOwner: {
    methodKind: "unary";
    input: typeof AutocompleteBusinessOwnerRequestSchema;
    output: typeof AutocompleteBusinessOwnerResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.CreateBusinessOwner
   */
  createBusinessOwner: {
    methodKind: "unary";
    input: typeof CreateBusinessOwnerRequestSchema;
    output: typeof CreateBusinessOwnerResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateBusinessOwner
   */
  updateBusinessOwner: {
    methodKind: "unary";
    input: typeof UpdateBusinessOwnerRequestSchema;
    output: typeof UpdateBusinessOwnerResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdatePointOfContact
   */
  updatePointOfContact: {
    methodKind: "unary";
    input: typeof UpdatePointOfContactRequestSchema;
    output: typeof UpdatePointOfContactResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.LinkSolutionsToCompany
   */
  linkSolutionsToCompany: {
    methodKind: "unary";
    input: typeof LinkSolutionsToCompanyRequestSchema;
    output: typeof LinkSolutionsToCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.CreateOrgCompanyEngagement
   */
  createOrgCompanyEngagement: {
    methodKind: "unary";
    input: typeof CreateOrgCompanyEngagementRequestSchema;
    output: typeof CreateOrgCompanyEngagementResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateOrgCompanyEngagement
   */
  updateOrgCompanyEngagement: {
    methodKind: "unary";
    input: typeof UpdateOrgCompanyEngagementRequestSchema;
    output: typeof UpdateOrgCompanyEngagementResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateEngagementInherentRisk
   */
  updateEngagementInherentRisk: {
    methodKind: "unary";
    input: typeof UpdateEngagementInherentRiskRequestSchema;
    output: typeof UpdateEngagementInherentRiskResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.DeleteOrgCompanyEngagement
   */
  deleteOrgCompanyEngagement: {
    methodKind: "unary";
    input: typeof DeleteOrgCompanyEngagementRequestSchema;
    output: typeof DeleteOrgCompanyEngagementResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ReprojectOrgCompany
   */
  reprojectOrgCompany: {
    methodKind: "unary";
    input: typeof ReprojectOrgCompanyRequestSchema;
    output: typeof ReprojectOrgCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ReprojectOrgCompanyEngagement
   */
  reprojectOrgCompanyEngagement: {
    methodKind: "unary";
    input: typeof ReprojectOrgCompanyEngagementRequestSchema;
    output: typeof ReprojectOrgCompanyEngagementResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateOrgCompanyReAssessmentDueDate
   */
  updateOrgCompanyReAssessmentDueDate: {
    methodKind: "unary";
    input: typeof UpdateOrgCompanyReAssessmentDueDateRequestSchema;
    output: typeof UpdateOrgCompanyReAssessmentDueDateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanySubprocessors
   */
  getCompanySubprocessors: {
    methodKind: "unary";
    input: typeof GetCompanySubprocessorsRequestSchema;
    output: typeof GetCompanySubprocessorsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ReanalyzeCompanySubprocessors
   */
  reanalyzeCompanySubprocessors: {
    methodKind: "unary";
    input: typeof ReanalyzeCompanySubprocessorsRequestSchema;
    output: typeof ReanalyzeCompanySubprocessorsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ListAggregatedSubprocessors
   */
  listAggregatedSubprocessors: {
    methodKind: "unary";
    input: typeof ListAggregatedSubprocessorsRequestSchema;
    output: typeof ListAggregatedSubprocessorsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetInherentRiskTemplate
   */
  getInherentRiskTemplate: {
    methodKind: "unary";
    input: typeof GetInherentRiskTemplateRequestSchema;
    output: typeof GetInherentRiskTemplateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.UpdateInherentRiskTemplate
   */
  updateInherentRiskTemplate: {
    methodKind: "unary";
    input: typeof UpdateInherentRiskTemplateRequestSchema;
    output: typeof UpdateInherentRiskTemplateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.ResetInherentRiskTemplate
   */
  resetInherentRiskTemplate: {
    methodKind: "unary";
    input: typeof ResetInherentRiskTemplateRequestSchema;
    output: typeof ResetInherentRiskTemplateResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.DeleteOrgCompany
   */
  deleteOrgCompany: {
    methodKind: "unary";
    input: typeof DeleteOrgCompanyRequestSchema;
    output: typeof DeleteOrgCompanyResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.SearchEngagementCandidates
   */
  searchEngagementCandidates: {
    methodKind: "unary";
    input: typeof SearchEngagementCandidatesRequestSchema;
    output: typeof SearchEngagementCandidatesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CompanyInventoryService.GetCompanyAIPosture
   */
  getCompanyAIPosture: {
    methodKind: "unary";
    input: typeof GetCompanyAIPostureRequestSchema;
    output: typeof GetCompanyAIPostureResponseSchema;
  },
  /**
   * Support-only. Overrides the classifier's AI profile on the GLOBAL catalog company behind this
   * inventory row, so every tenant that has the vendor sees the new verdict.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.OverrideCompanyAIProfile
   */
  overrideCompanyAIProfile: {
    methodKind: "unary";
    input: typeof OverrideCompanyAIProfileRequestSchema;
    output: typeof OverrideCompanyAIProfileResponseSchema;
  },
  /**
   * Support-only. Queues a forced classifier re-run; asynchronous, the profile changes when it completes.
   *
   * @generated from rpc inventory.v1.CompanyInventoryService.ReclassifyCompanyAIProfile
   */
  reclassifyCompanyAIProfile: {
    methodKind: "unary";
    input: typeof ReclassifyCompanyAIProfileRequestSchema;
    output: typeof ReclassifyCompanyAIProfileResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_company_service, 0);

